// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:36:10.819Z
// Property: Sunchase Ridgeland Apts. (ID: 6767906449165630)
// Collections: 18 amenities, 4 floorplans (live), 19 photos, 57 POIs, 1 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165630",
  "property_external_id": "jbw8mp4",
  "property_zillow_url": "https://www.zillow.com/apartments/ridgeland-ms/sunchase-ridgeland-apts./5XrN3L/",
  "property_apartments_url": "https://www.apartments.com/sunchase-ridgeland-apts-ridgeland-ms/jbw8mp4/",
  "property_google_business_url": "https://www.google.com/maps/place/Sunchase+Ridgeland+Apartments/data=!4m2!3m1!1s0x0:0xe8921af59f0d0fa1?sa=X&ved=2ahUKEwj0n-CWgL2SAxXLSDABHTsdPGsQ_BJ6BAg9EAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/company/sunchase-holdings#:~:text=SunChase%20and%20related%20entities%20are,focus%20has%20been%20distressed%20assets.",
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "sunchase-ridgeland-apts.",
  "property_name": "Sunchase Ridgeland Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/ms/ridgeland/sunchase-ridgeland/",
  "property_domain": null,
  "property_address": "875 William Blvd",
  "property_full_address": "875 William Blvd, Ridgeland, MS, 39157",
  "property_address_1": "875 William Blvd",
  "property_address_2": null,
  "property_address_city": "Ridgeland",
  "property_address_state": "MS",
  "property_address_zip_full": null,
  "property_address_zip": "39157",
  "property_address_country": "US",
  "property_address_county": "Madison County",
  "property_neighborhood_address": "Outer Ridgeland/Madison",
  "property_address_latitude": "32.4059",
  "property_address_longitude": "-90.1026",
  "property_email": "sunchaseridgeland@caseusa.com",
  "property_phone": "(601) 908-2633",
  "property_call_tracking_phone": "844-325-5999",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Sunchase Ridgeland Apts., where comfort and convenience marry in beautiful harmony. Choose from spacious one and two-bedroom floor plans, and indulge in premium amenities like a sparkling pool, well-equipped fitness center, and inviting clubhouse. Your ideal lifestyle awaits—explore our availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Sunchase Ridgeland Apartments, your serene oasis in the heart of Ridgeland, Mississippi. Our community offers thoughtfully designed floor plans featuring spacious one and two-bedroom apartments, perfect for singles, couples, or families. Whether you’re looking for a cozy retreat or a roomy space to entertain, Sunchase Ridgeland has the perfect fit for you—view all our options to discover your ideal home.\n\nAt Sunchase Ridgeland, we prioritize both comfort and convenience with a host of outstanding amenities. Dive into relaxation at our sparkling pool, stay active in our fully-equipped fitness center, and enjoy social gatherings in our welcoming clubhouse. Our Wi-Fi-enabled spaces and business center provide everything you need to work and play seamlessly.\n\nSafety and maintenance are paramount; our dedicated on-site property manager and 24-hour maintenance ensure peace of mind. Benefit from additional conveniences such as laundry facilities, online services, and laundry service for hassle-free living. With smoke-free living, high-speed internet access, and modern features like air conditioning, walk-in closets, and a well-equipped kitchen, our apartments deliver the comfort you seek.\n\nStep outside to enjoy your private balcony or patio, taking in the fresh air and beautiful views. The thoughtfully designed interior spaces include ample storage, cozy fireplaces, and upgraded finishes.\n\nDon’t wait to find your new home at Sunchase Ridgeland Apartments! Browse our availability or schedule a tour today to experience the ideal blend of modern living and community warmth. Discover your perfect home in Ridgeland!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-3e77-776b-a3a7-7c013102a522.webp",
  "property_featured_image_media": {
    "alt_text": "SunChase Apartment Homes monument sign with landscaping.",
    "public_id": "019cfb48-3e77-776b-a3a7-7c013102a522",
    "storage_key": "property/6767906449165630/019cfb48-3e77-776b-a3a7-7c013102a522.webp",
    "width": 1000,
    "height": 600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "413",
  "property_year_built": "1985",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "20",
  "property_pet_restrictions": "Certain Breeds",
  "property_pet_policy_description": "Above applies to pets up to 40-80lbs",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://sunchaseapartmentsridgeland.securecafe.com/onlineleasing/sunchase-ridgeland-apts/floorplans.aspx",
  "property_resident_portal_url": "https://sunchaseapartmentsridgeland.securecafe.com/residentservices/sunchase-ridgeland-apts/userlogin.aspx",
  "property_apply_now_url": "https://sunchaseapartmentsridgeland.securecafe.com/onlineleasing/sunchase-ridgeland-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-5b74-75e2-9dfa-0dfacd18a365.webp",
  "property_primary_logo_media": {
    "alt_text": "SunChase Apartment Homes logo",
    "public_id": "019cfb48-5b74-75e2-9dfa-0dfacd18a365",
    "storage_key": "property/6767906449165630/019cfb48-5b74-75e2-9dfa-0dfacd18a365.webp",
    "width": 1421,
    "height": 800
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb49-1b5f-7710-bbf2-958a5620f84f.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb49-1b5f-7710-bbf2-958a5620f84f",
    "storage_key": "property/6767906449165630/019cfb49-1b5f-7710-bbf2-958a5620f84f.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb49-2da3-7518-8601-537843509781.webp",
  "property_mono_white_logo_media": {
    "alt_text": "SunChase Apartment Homes logo",
    "public_id": "019cfb49-2da3-7518-8601-537843509781",
    "storage_key": "property/6767906449165630/019cfb49-2da3-7518-8601-537843509781.webp",
    "width": 640,
    "height": 360
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb49-359a-7227-9e27-7e942305f017.webp",
  "property_mono_black_logo_media": {
    "alt_text": "SunChase Apartment Homes logo.",
    "public_id": "019cfb49-359a-7227-9e27-7e942305f017",
    "storage_key": "property/6767906449165630/019cfb49-359a-7227-9e27-7e942305f017.webp",
    "width": 640,
    "height": 360
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#5d3932",
  "property_secondary_color": "#cac4b8",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#d4af37",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "725 - 925",
  "property_sqft_min": "725",
  "property_sqft_max": "925",
  "property_price_range": "1059 - 1309",
  "property_price_min": "1059",
  "property_price_max": "1309",
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/SunchaseApartmentsRidgeland/photos/d41d8cd9/1572413027692690/",
  "property_instagram_url": "https://www.instagram.com/sunchaseridgeland/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJSz84FKbTKYYRoQ8Nn_Uakug",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/sunchase-ridgeland-apartments-ridgeland-3",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sunchase Ridgeland Apts.",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Home",
  "property_home_amenities_blurb": "Welcome to Sunchase Ridgeland Apts., where modern living meets comfort in beautiful Ridgeland, Mississippi. Choose from spacious one and two-bedroom floor plans, and enjoy amenities like a refreshing pool, fitness center, and inviting clubhouse. Elevate your lifestyle with our smoke-free, Wi-Fi-empowered community that truly feels like home.",
  "property_home_floorplans_blurb": "Welcome to Sunchase Ridgeland Apts., where comfort meets style in the heart of Ridgeland, Mississippi. Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Ready to elevate your living experience? Browse our available apartment homes and find your perfect fit today!",
  "property_home_gallery_blurb": "At Sunchase Ridgeland Apts., indulge in stylish living with spacious one and two-bedroom floor plans. Soak up the sun by the pool, enjoy the fitness center, and unwind in our inviting clubhouse. With modern amenities and 24-hour access, picture yourself thriving in this vibrant Ridgeland community!",
  "property_home_neighborhood_blurb": "Welcome to Sunchase Ridgeland Apts., your ideal sanctuary in Mississippi. Nestled near serene parks like LeFleur's Bluff State Park and Freedom Ridge, our one- and two-bedroom floor plans provide the perfect backdrop for relaxation. Enjoy vibrant community life just moments from museums, fitness centers, and local attractions. Live your best life here!",
  "property_home_reviews_blurb": "Welcome to Sunchase Ridgeland Apts., where safety meets affordability. Our residents rave about the \"clean and well-maintained grounds\" and the \"friendly and accommodating\" staff. With features like a stunning indoor pool, spacious layouts, and ample parking, you'll feel right at home in our vibrant community. Join us today!",
  "property_neighborhood_blurb": "At Sunchase Ridgeland Apartments, your vibrant lifestyle intertwines with convenience and leisure. Nestled in Ridgeland, MS, you're moments away from serene parks like LeFleur's Bluff State Park and engaging spots like the Mississippi Children's Museum. Embrace community living where adventure meets tranquility—your perfect home awaits!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Sunchase Ridgeland Apts., your comfort meets convenience. Whether you're soaking up the sun by the pool, breaking a sweat in our fitness center, or enjoying a cozy evening by the fireplace, our thoughtfully designed apartments offer everything you need to thrive in Ridgeland. Elevate your lifestyle here!",
  "property_applynow_blurb": "Nestled in the heart of Ridgeland, Sunchase Ridgeland Apts. offers stylish one- and two-bedroom floor plans with modern amenities. From invigorating poolside afternoons to cozy evenings by the fireplace, your new home is just a click away. Embrace comfort and convenience—apply for your new apartment today!",
  "property_contactus_blurb": "At Sunchase Ridgeland Apts., we offer thoughtfully designed one and two-bedroom floor plans that blend comfort with style. Located in the heart of Ridgeland, Mississippi, your ideal home awaits. Have questions? Our leasing team is just a message away, ready to assist you in finding your perfect fit!",
  "property_faqs_blurb": "At Sunchase Ridgeland Apts., our thoughtfully designed one- and two-bedroom floor plans cater to your lifestyle in beautiful Ridgeland, Mississippi. Have questions? Our FAQ page is a treasure trove of insights to help you uncover the perfect home and community experience waiting for you.",
  "property_floorplans_blurb": "At Sunchase Ridgeland Apts. in picturesque Ridgeland, Mississippi, comfort meets style with our thoughtfully designed one and two-bedroom floor plans. Each space offers modern amenities and a cozy atmosphere that suits your lifestyle. Unveil your ideal home today—browse our available apartment homes to find your perfect fit!",
  "property_gallery_blurb": "At Sunchase Ridgeland Apts., vibrant living meets comfort. With inviting one and two-bedroom floor plans, enjoy amenities like a shimmering pool, a state-of-the-art fitness center, and spacious walk-in closets. Picture yourself relaxing on your balcony or cozying up by the fireplace—your perfect home awaits in Ridgeland, Mississippi!",
  "property_interactivemap_blurb": "At Sunchase Ridgeland Apts., vibrant living awaits in our thoughtfully designed one and two-bedroom homes. Enjoy the sun by the pool, stay fit in our modern gym, or unwind in the clubhouse. Use our interactive community map to find your perfect apartment today and step into a life of comfort!",
  "property_pets_blurb": "At Sunchase Ridgeland Apts., experience a harmonious blend of modern living and community charm in the heart of Ridgeland, MS. Our pet-friendly residences cater to furry companions under 40lbs. Revel in spacious layouts and inviting amenities, all while enjoying the vibrant lifestyle this delightful area has to offer.",
  "property_referafriend_blurb": "At Sunchase Ridgeland Apts., we celebrate the joy of community. With spacious one- and two-bedroom floor plans, your perfect home awaits in Ridgeland, Mississippi. Share the love—refer a friend today and enjoy the comfort of great neighbors right beside you! Make memories that last a lifetime.",
  "property_residentaccess_blurb": "Welcome to Sunchase Ridgeland Apts., where comfort meets convenience in the heart of Ridgeland, Mississippi. Choose from our stylish one and two-bedroom floor plans designed for modern living. Access your resident portal today to manage rent payments, schedule maintenance, and enjoy your community to the fullest!",
  "property_reviews_blurb": "At Sunchase Ridgeland Apts., residents celebrate a vibrant community where safety meets affordability. \"You're not treated as a 'renter' but as a real resident,\" shared a loyal tenant. Enjoy friendly staff, pristine grounds, and an inviting indoor pool. Experience the comforts and convenience that make Sunchase feel like home!",
  "property_created_at": "1753982393047",
  "property_scheduletour_blurb": "At Sunchase Ridgeland Apts. in picturesque Ridgeland, Mississippi, choose from stylish one- or two-bedroom floor plans designed for comfort and luxury. Schedule a tour today to experience our vibrant community and hear firsthand why our residents love calling Sunchase their home! Embrace a lifestyle where every detail matters.",
  "property_thankyou_blurb": "Thank you for reaching out! Sunchase Ridgeland Apts. offers inviting one and two-bedroom floor plans designed for comfort and style. Located in beautiful Ridgeland, Mississippi, your ideal home awaits. Our team will be in touch soon to help you take the next step toward your new living experience!",
  "property_virtualtours_blurb": "At Sunchase Ridgeland Apts. in Ridgeland, Mississippi, our thoughtfully designed one- and two-bedroom apartments offer the perfect blend of comfort and style. Immerse yourself in a vibrant community—take a virtual tour today and envision your new life at Sunchase! Your ideal home awaits.",
  "property_copyright": "2025 All Rights Reserved. Sunchase Ridgeland Apts.",
  "property_seo_title_home": "Sunchase Ridgeland Apts. |  Apartments in Ridgeland, Mississippi",
  "property_seo_description_home": "Discover modern living at Sunchase Ridgeland Apts! Enjoy spacious layouts, resort-style amenities, and a vibrant community. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Ridgeland, Mississippi Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Sunchase Ridgeland Apts. in Mississippi! Choose from stylish one or two-bedroom floor plans tailored for comfort and convenience.",
  "property_seo_title_amenities": "Amenities | Ridgeland, Mississippi Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort and convenience at Sunchase Ridgeland Apts with a pool, fitness center, and stylish apartments in beautiful Ridgeland!",
  "property_seo_title_gallery": "Gallery | Apartments in Ridgeland, Mississippi",
  "property_seo_description_gallery": "At Sunchase Ridgeland Apts., vibrant living awaits! Imagine relaxing by the pool, enjoying 24/7 access, and savoring modern amenities. Picture your new life!",
  "property_seo_title_virtualtours": "Virtual Tours | Sunchase Ridgeland Apts. Apartments",
  "property_seo_description_virtualtours": "Experience Sunchase Ridgeland Apts. from your screen! Take a virtual tour of our one and two-bedroom homes in the heart of Ridgeland, Mississippi.",
  "property_seo_title_interactivemap": "Interactive Map | Sunchase Ridgeland Apts. Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Sunchase Ridgeland Apts.! Enjoy luxury amenities and spacious layouts in Ridgeland, MS. Explore now!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Ridgeland, Mississippi",
  "property_seo_description_neighborhood": "Uncover vibrant living at Sunchase Ridgeland Apts! Enjoy our diverse floor plans and nearby local gems in Ridgeland, MS. Your new neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | Sunchase Ridgeland Apts.",
  "property_seo_description_contact": "Experience comfort and style at Sunchase Ridgeland Apts. in Ridgeland, MS. Choose from one or two-bedroom floor plans. Have questions? Reach out to our team!",
  "property_seo_title_faqs": "FAQs | Apartments in Ridgeland, Mississippi",
  "property_seo_description_faqs": "Discover everything about Sunchase Ridgeland Apts. from amenities to floor plans on our FAQs page—your guide to the perfect home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Ridgeland, Mississippi",
  "property_seo_description_reviews": "Join the vibrant community at Sunchase Ridgeland Apts! See what residents love about our amenities, location, and the comfort of home in Mississippi.",
  "property_seo_title_applynow": "Apply Now | Apartments in Ridgeland, Mississippi",
  "property_seo_description_applynow": "Elevate your lifestyle at Sunchase Ridgeland Apts. in Ridgeland, MS. Enjoy modern amenities and spacious floor plans—apply online for your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Sunchase Ridgeland Apts.",
  "property_seo_description_residentaccess": "Log into Sunchase Ridgeland Apts' resident portal for quick rent payments, maintenance requests, and community updates—all at your fingertips in Ridgeland, MS!",
  "property_seo_title_referafriend": "Refer A Friend | Sunchase Ridgeland Apts.",
  "property_seo_description_referafriend": "Refer a friend to Sunchase Ridgeland Apts and enjoy the perks of great neighbors! Share the joy of comfortable living in beautiful Ridgeland, MS today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Sunchase Ridgeland Apts.",
  "property_seo_description_scheduletour": "Discover Sunchase Ridgeland Apts. in Mississippi. Enjoy modern living and vibrant amenities. Schedule your tour and envision your future home!",
  "property_seo_title_privacy": "Privacy Policy | Sunchase Ridgeland Apts.",
  "property_seo_description_privacy": "At Sunchase Ridgeland Apts, your privacy is our priority. Discover how we safeguard your information. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Sunchase Ridgeland Apts.",
  "property_seo_description_accessibility": "At Sunchase Ridgeland Apts., we prioritize digital inclusion and accessibility for all. Join us in creating a welcoming community in beautiful Ridgeland, MS!",
  "property_seo_title_sitemap": "Sitemap | Sunchase Ridgeland Apts.",
  "property_seo_description_sitemap": "Unlock a world of convenience at Sunchase Ridgeland Apts. Navigate our sitemap to find the perfect home in the heart of Ridgeland, MS. Your oasis awaits!",
  "property_seo_title_thankyou": "Thank You | Sunchase Ridgeland Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out! We're excited to connect with you about Sunchase Ridgeland Apts. Your dream home in Mississippi awaits—stay tuned for our reply!",
  "property_seo_title_pets": "Pet Policy | Apartments in Ridgeland, MS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865856377",
  "amenities": [
    {
      "id": "ec_5259a0572b17d54e31688bcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127397196",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2d33612ad1769acb1e4ca9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127397198",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8bbd932a472cc761acaf2ed8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127397199",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd07473bfa5b7cfb32a70198",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127397200",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da96a156751975cb3334753f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127397201",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5978cb95e3157c40d2a2d5e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127397202",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5537ead8a2de787b9cd8da7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127397203",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65c80ccda7a902470087dbe7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "128042572",
      "title": "Comcast",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b16c3398820271444148a1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127397204",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4869d567bcbd1718e06fa63b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "128017291",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ff129e2847384de0fc3cab2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127398656",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10b311e15d2b36cf398f39b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127398657",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9674e85f13bef806de6e04a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127398658",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33c3122617c469bc48d9c8b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127398659",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c0fea1544d097b4c5a3b9f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127398660",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed539ad1287d8ffdf0dfd108",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127398661",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3242a87e77791b5e165af675",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127398662",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1099a380b8306c0b77c6676",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "yardi",
      "external_id": "127398663",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4c36fd0e-0452-4a01-8bd4-bfba68a23cc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-5be3-72aa-aba5-97efdf83a168.webp",
      "image_media": {
        "alt_text": "Exterior entrance of Sunchase Apartment Homes with glass doors and sunburst logo, surrounded by potted plants.",
        "public_id": "019cfb48-5be3-72aa-aba5-97efdf83a168",
        "storage_key": "property/6767906449165630/019cfb48-5be3-72aa-aba5-97efdf83a168.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of the Sunchase Apartment Homes entrance with glass doors and welcoming landscaping.",
      "link": "",
      "alt_text": "Exterior entrance of Sunchase Apartment Homes with glass doors and sunburst logo, surrounded by potted plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F034a8df1c97722259be94ff4ed496544.webp"
    },
    {
      "id": "custom_c09332a0-2060-48af-a27f-491e81a1d54a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20b0-105f-76ef-bc25-7eb7bf944b2c.webp",
      "image_media": {
        "alt_text": "SunChase Apartment Homes monument sign with landscaping.",
        "public_id": "019d20b0-105f-76ef-bc25-7eb7bf944b2c",
        "storage_key": "property/6767906449165630/019d20b0-105f-76ef-bc25-7eb7bf944b2c.webp",
        "width": 1000,
        "height": 600
      },
      "title": "Community",
      "description": "Welcome to SunChase Apartment Homes, featuring a beautifully designed monument sign with natural stone and lush landscaping.",
      "link": "",
      "alt_text": "SunChase Apartment Homes monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-3e77-776b-a3a7-7c013102a522.webp"
    },
    {
      "id": "custom_90741e85-90ca-4a50-b172-64284af5944d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20af-d6e7-74e2-909d-65e187b85633.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-family building with a wooden ramp, walkway, and landscaped lawn.",
        "public_id": "019d20af-d6e7-74e2-909d-65e187b85633",
        "storage_key": "property/6767906449165630/019d20af-d6e7-74e2-909d-65e187b85633.webp",
        "width": 1600,
        "height": 1282
      },
      "title": "Community",
      "description": "Exterior view of a contemporary apartment community with landscaped grounds and accessible entryways.",
      "link": "",
      "alt_text": "Exterior view of a multi-family building with a wooden ramp, walkway, and landscaped lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2Fda915a70f8ce08a74bfa378ded9c4674.webp"
    },
    {
      "id": "custom_399ba7ea-e2df-4f30-89ca-04b7d8e1c05d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20af-ccdb-733d-be5d-93d5ef7fecd0.webp",
      "image_media": {
        "alt_text": "Exterior view of a two-story apartment building with balconies and landscaped shrubbery.",
        "public_id": "019d20af-ccdb-733d-be5d-93d5ef7fecd0",
        "storage_key": "property/6767906449165630/019d20af-ccdb-733d-be5d-93d5ef7fecd0.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior photo of a multifamily community showing two-story units, entry doors, and tidy landscaping.",
      "link": "",
      "alt_text": "Exterior view of a two-story apartment building with balconies and landscaped shrubbery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F61cc14006d23545a8b1c5b65989a4036.webp"
    },
    {
      "id": "custom_21dee8fa-d4d0-4441-8b20-7dfedfa790af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20af-ee8b-732c-a6a0-8692d2e6c985.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with stone accents, balconies, and landscaped grounds.",
        "public_id": "019d20af-ee8b-732c-a6a0-8692d2e6c985",
        "storage_key": "property/6767906449165630/019d20af-ee8b-732c-a6a0-8692d2e6c985.webp",
        "width": 993,
        "height": 794
      },
      "title": "Community",
      "description": "Exterior view of a multifamily community featuring stone façades, balconies, and manicured landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with stone accents, balconies, and landscaped grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F6a815bf8229aceb967adb1550dee60af.webp"
    },
    {
      "id": "custom_5d285c2e-a1d1-4285-8a1f-dba6871dea06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-5bb8-765b-8c12-46e9aee88d6a.webp",
      "image_media": {
        "alt_text": "Indoor pool area with glass walls, wooden beams, and lush plants.",
        "public_id": "019cfb48-5bb8-765b-8c12-46e9aee88d6a",
        "storage_key": "property/6767906449165630/019cfb48-5bb8-765b-8c12-46e9aee88d6a.webp",
        "width": 1600,
        "height": 1282
      },
      "title": "Community",
      "description": "Indoor pool and lounge in a residential community with glass walls, wooden beams, and lush plants.",
      "link": "",
      "alt_text": "Indoor pool area with glass walls, wooden beams, and lush plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F99b1391166a8b8007243d9ba9e3b53b1.webp"
    },
    {
      "id": "custom_bc2dea33-7080-4b2a-b39c-6d136d9a1993",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-5bae-7065-ae17-817e60e82894.webp",
      "image_media": {
        "alt_text": "Indoor community pool area with glass walls, skylights, and wooden beams.",
        "public_id": "019cfb48-5bae-7065-ae17-817e60e82894",
        "storage_key": "property/6767906449165630/019cfb48-5bae-7065-ae17-817e60e82894.webp",
        "width": 1600,
        "height": 1282
      },
      "title": "Community",
      "description": "Bright indoor pool area in a residential community, featuring glass walls, skylights, and lush plants.",
      "link": "",
      "alt_text": "Indoor community pool area with glass walls, skylights, and wooden beams.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F4e1afd266a5a29359c7878a8a9105e98.webp"
    },
    {
      "id": "custom_74bcb855-a8fe-4878-8192-c90a91937b90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-5c01-72ed-a762-f01b1f089044.webp",
      "image_media": {
        "alt_text": "Bright indoor fitness center with treadmills, elliptical, weights and benches.",
        "public_id": "019cfb48-5c01-72ed-a762-f01b1f089044",
        "storage_key": "property/6767906449165630/019cfb48-5c01-72ed-a762-f01b1f089044.webp",
        "width": 1600,
        "height": 1282
      },
      "title": "Community",
      "description": "Well-equipped community fitness center with cardio machines and free weights at the property.",
      "link": "",
      "alt_text": "Bright indoor fitness center with treadmills, elliptical, weights and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F68d4767a430d77ee13b834ae3b136920.webp"
    },
    {
      "id": "custom_cc259201-6cd6-4058-a917-44cff66a55c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-5bb8-765b-8c12-430a604ac024.webp",
      "image_media": {
        "alt_text": "Bright resident lounge with a fireplace, beige walls, teal chairs, and a wall-mounted TV.",
        "public_id": "019cfb48-5bb8-765b-8c12-430a604ac024",
        "storage_key": "property/6767906449165630/019cfb48-5bb8-765b-8c12-430a604ac024.webp",
        "width": 1600,
        "height": 1282
      },
      "title": "Community",
      "description": "A stylish community lounge with a fireplace, contemporary seating, and a large wall TV for residents.",
      "link": "",
      "alt_text": "Bright resident lounge with a fireplace, beige walls, teal chairs, and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F8640bbf5557feabeed0802a22f02befb.webp"
    },
    {
      "id": "custom_72f129a9-47d6-4691-a65a-e5082f96535e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20af-e440-751b-b151-490e9d1f3762.webp",
      "image_media": {
        "alt_text": "Indoor residential garage with a blue sectional door, concrete floor, and a view of green outdoors.",
        "public_id": "019d20af-e440-751b-b151-490e9d1f3762",
        "storage_key": "property/6767906449165630/019d20af-e440-751b-b151-490e9d1f3762.webp",
        "width": 1254,
        "height": 836
      },
      "title": "Community",
      "description": "Modern resident garage space with a blue sectional door, clean concrete floor, and a view of outdoors.",
      "link": "",
      "alt_text": "Indoor residential garage with a blue sectional door, concrete floor, and a view of green outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F5a58b1375e235a894acef839a0416c38.jpg"
    },
    {
      "id": "custom_bc1f1872-fdbe-41bc-a8c7-803f6385ddec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20af-e980-7390-b9a4-208280e65c46.webp",
      "image_media": {
        "alt_text": "Well-lit apartment community gym with free weights, benches, and weight machines.",
        "public_id": "019d20af-e980-7390-b9a4-208280e65c46",
        "storage_key": "property/6767906449165630/019d20af-e980-7390-b9a4-208280e65c46.webp",
        "width": 1254,
        "height": 836
      },
      "title": "Community",
      "description": "On-site fitness center with free weights and weight machines for residents.",
      "link": "",
      "alt_text": "Well-lit apartment community gym with free weights, benches, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F7a52c218c963a8b56f99121593388542.jpg"
    },
    {
      "id": "custom_95277d0d-99e0-40eb-aa9e-cfd9e99f668a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20af-cbc6-73c3-9647-19d34b48589c.webp",
      "image_media": {
        "alt_text": "Living room in a modern apartment with a gray sectional sofa and open kitchen.",
        "public_id": "019d20af-cbc6-73c3-9647-19d34b48589c",
        "storage_key": "property/6767906449165630/019d20af-cbc6-73c3-9647-19d34b48589c.webp",
        "width": 1600,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright, open-concept living area in a modern apartment with a large gray sectional and a kitchen island.",
      "link": "",
      "alt_text": "Living room in a modern apartment with a gray sectional sofa and open kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F9ede2cf38f87d1c8f0ae11d105fc61c6.webp"
    },
    {
      "id": "custom_cd133086-3377-4c94-9def-00213f0ac250",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20af-df42-765c-961d-44ab9c4a97ae.webp",
      "image_media": {
        "alt_text": "Bright living room with sofa, two fluffy ottomans, fireplace, plants, and sliding glass door to balcony.",
        "public_id": "019d20af-df42-765c-961d-44ab9c4a97ae",
        "storage_key": "property/6767906449165630/019d20af-df42-765c-961d-44ab9c4a97ae.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A bright, modern living room with a white sofa, fluffy ottomans, greenery, a fireplace, and balcony access.",
      "link": "",
      "alt_text": "Bright living room with sofa, two fluffy ottomans, fireplace, plants, and sliding glass door to balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F3daee6adcd270c68f80fa5e4f68b777d.webp"
    },
    {
      "id": "custom_6677d7b2-c779-466d-8bb9-e7bfd682e0b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-6404-74eb-91c2-249820c8954f.webp",
      "image_media": {
        "alt_text": "Open-concept living room in a white apartment, featuring a white sofa, coral chair, and dining area.",
        "public_id": "019cfb48-6404-74eb-91c2-249820c8954f",
        "storage_key": "property/6767906449165630/019cfb48-6404-74eb-91c2-249820c8954f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright, modern living area in an apartment with a white sofa, coral chair, and a dining nook.",
      "link": "",
      "alt_text": "Open-concept living room in a white apartment, featuring a white sofa, coral chair, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F7af97b320ba6a44bccf10f0df75ddb30.webp"
    },
    {
      "id": "custom_c4a91dc1-f0be-4106-99fe-8cd9201e922a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20af-ee37-7349-a9a5-2aa9d3360068.webp",
      "image_media": {
        "alt_text": "Sunset over a river with a steel truss bridge and a tugboat, framed by trees.",
        "public_id": "019d20af-ee37-7349-a9a5-2aa9d3360068",
        "storage_key": "property/6767906449165630/019d20af-ee37-7349-a9a5-2aa9d3360068.webp",
        "width": 1586,
        "height": 594
      },
      "title": "Lifestyle",
      "description": "Scenic riverfront view featuring a steel truss bridge and a tugboat, framed by trees.",
      "link": "",
      "alt_text": "Sunset over a river with a steel truss bridge and a tugboat, framed by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F5ff983c3110dbb14763e46ebd62e0225.webp"
    },
    {
      "id": "custom_b68d5bdd-8e76-4226-b653-545c28491934",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20af-dfcc-7765-a18c-39f27d93d0db.webp",
      "image_media": {
        "alt_text": "Exterior view of a bright yellow Big Texan building with flags and parked cars.",
        "public_id": "019d20af-dfcc-7765-a18c-39f27d93d0db",
        "storage_key": "property/6767906449165630/019d20af-dfcc-7765-a18c-39f27d93d0db.webp",
        "width": 1365,
        "height": 768
      },
      "title": "Community",
      "description": "Exterior of a Texas-style Big Texan building with bold signage, flags, and festive garland.",
      "link": "",
      "alt_text": "Exterior view of a bright yellow Big Texan building with flags and parked cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F9c3baf42346e61d7987828057ed67272.jpg"
    },
    {
      "id": "custom_e3c94986-8c25-4240-81d6-167277db2b94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20af-ef10-76ae-ae38-51a77d405746.webp",
      "image_media": {
        "alt_text": "Person holding a white travel mug with a black lid beside a bicycle",
        "public_id": "019d20af-ef10-76ae-ae38-51a77d405746",
        "storage_key": "property/6767906449165630/019d20af-ef10-76ae-ae38-51a77d405746.webp",
        "width": 698,
        "height": 797
      },
      "title": "Lifestyle",
      "description": "Lifestyle image of a resident with a bike, highlighting active living around the community.",
      "link": "",
      "alt_text": "Person holding a white travel mug with a black lid beside a bicycle",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2F301c52f434bc61b47e662744522cd5ea.webp"
    },
    {
      "id": "custom_266d6b4b-f565-40ef-b914-d0e825412306",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20af-f56a-741a-94d4-ce9ea10bee92.webp",
      "image_media": {
        "alt_text": "Line of children with backpacks waiting to board a yellow school bus.",
        "public_id": "019d20af-f56a-741a-94d4-ce9ea10bee92",
        "storage_key": "property/6767906449165630/019d20af-f56a-741a-94d4-ce9ea10bee92.webp",
        "width": 788,
        "height": 663
      },
      "title": "Lifestyle",
      "description": "Children with backpacks line up to board a yellow school bus, ready for the day.",
      "link": "",
      "alt_text": "Line of children with backpacks waiting to board a yellow school bus.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2Fb0bee95f570abd714e166175fc587c80.webp"
    },
    {
      "id": "custom_72cc40ef-265a-441c-a732-2cb89a0b50be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d20af-f950-761b-8b68-0cc9f68072f3.webp",
      "image_media": {
        "alt_text": "Outdoor pedestrian plaza with brick storefronts, planters, and people walking.",
        "public_id": "019d20af-f950-761b-8b68-0cc9f68072f3",
        "storage_key": "property/6767906449165630/019d20af-f950-761b-8b68-0cc9f68072f3.webp",
        "width": 788,
        "height": 469
      },
      "title": "Lifestyle",
      "description": "Exterior community plaza with shops and greenery at the apartment property.",
      "link": "",
      "alt_text": "Outdoor pedestrian plaza with brick storefronts, planters, and people walking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165630%2Fbfaeabed484fa12a5688bbfa30b49fcf.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_33899119-d399-4144-bf6d-9f4adc73edc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Topgolf Ridgeland",
      "poi_type": "Restaurants",
      "poi_address": "102 Topgolf Way, Ridgeland, MS 39157, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun golfing experience with a variety of games and a lively atmosphere, and the food can be tasty.\n\nOther reviews mention the service can be slow and the staff can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-8314-73ad-a1d1-093c9ecd38de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8314-73ad-a1d1-093c9ecd38de",
        "storage_key": "property/6767906449165630/019d2709-8314-73ad-a1d1-093c9ecd38de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://topgolf.com/us/ridgeland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16464282719468580823&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-ridgeland",
      "poi_latitude": "32.4472705",
      "poi_longitude": "-90.1393271",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-612-0833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b335-715e-b806-2daa84587596.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b335-715e-b806-2daa84587596",
        "storage_key": "property/6767906449165630/019d2709-b335-715e-b806-2daa84587596.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUfCsXADRKYYR1--G3-bhfOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a58c6986-b3de-4720-9ebd-65b90f7c051c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Mama Hamil's Southern Cookin' and Bar B Que Buffet",
      "poi_type": "Restaurants",
      "poi_address": "480 Magnolia St, Madison, MS 39110, USA",
      "poi_short_description": "Big, buffet-style joint for Southern home cooking & BBQ with wood booths & communal tables.",
      "poi_long_description": "People say this barbecue restaurant offers a wide variety of Southern dishes, including fried chicken, ribs, and chicken livers and gizzards, as well as a buffet with many options. They highlight the excellent value, with fresh, hot food at a reasonable price, and the home-style cooking that tastes like grandma's. They also like the friendly and attentive staff, and the clean and spacious atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-8297-7353-8f89-69c70e3c61be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8297-7353-8f89-69c70e3c61be",
        "storage_key": "property/6767906449165630/019d2709-8297-7353-8f89-69c70e3c61be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hamils.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11010288085330032935&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mama-hamils-southern-cookin-and-bar-b-que-buffet",
      "poi_latitude": "32.4448008",
      "poi_longitude": "-90.1230138",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-856-4407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b335-715e-b806-2daa84587596.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b335-715e-b806-2daa84587596",
        "storage_key": "property/6767906449165630/019d2709-b335-715e-b806-2daa84587596.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3jiACfSKYYRJ_nPuK1mzJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_99db29ca-bbf6-47a6-b06c-bd33b6a5877e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Shaggy's on the Rez",
      "poi_type": "Restaurants",
      "poi_address": "1733 Spillway Rd, Brandon, MS 39047, USA",
      "poi_short_description": "Popular, lively restaurant and bar serving seafood-inspired fare and featuring outdoor seating with reservoir views.",
      "poi_long_description": "People say this restaurant serves delicious seafood, including lobster corn dogs, Royal Reds, and stuffed flounder. They highlight the fun, beachy atmosphere, especially on the outdoor deck with views of the reservoir, and the live music. They also like the attentive and friendly service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-83c6-77ab-9319-0290a8881c70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-83c6-77ab-9319-0290a8881c70",
        "storage_key": "property/6767906449165630/019d2709-83c6-77ab-9319-0290a8881c70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shaggys.com/locations/on-the-rez/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12606896511369096172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shaggys-on-the-rez",
      "poi_latitude": "32.3882456",
      "poi_longitude": "-90.04912420000001",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-724-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b335-715e-b806-2daa84587596.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b335-715e-b806-2daa84587596",
        "storage_key": "property/6767906449165630/019d2709-b335-715e-b806-2daa84587596.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJycGXC-nVKYYR7CtEOJWx9K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ef6a65d1-7597-4d59-9504-1e290887e75c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "988 Top St, Flowood, MS 39232, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food, including steak, fried fish, fried shrimp, and a fresh salad bar. They also highlight the friendly and attentive staff, and the excellent service.\n\nSome reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-82f6-776c-8f62-28bd0151e314.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-82f6-776c-8f62-28bd0151e314",
        "storage_key": "property/6767906449165630/019d2709-82f6-776c-8f62-28bd0151e314.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "https://www.goldencorral.com/locations/682/golden-corral-top-street?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=682",
      "poi_directions_map_url": "https://maps.google.com/?cid=5732979269932144382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "32.327924",
      "poi_longitude": "-90.121621",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 601-420-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b335-715e-b806-2daa84587596.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b335-715e-b806-2daa84587596",
        "storage_key": "property/6767906449165630/019d2709-b335-715e-b806-2daa84587596.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcdgWVRctKIYR_tb7eEWij08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_962bb6b9-4451-46c7-8b4d-8f2521fd2cc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "202 E Layfair Dr, Flowood, MS 39232, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fries, and toast. They highlight the food is hot, fresh, and moist, and the sauce is tasty. They also like the fast and efficient service, and the clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-87d6-71c0-ad0e-ae3b3ae21583.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-87d6-71c0-ad0e-ae3b3ae21583",
        "storage_key": "property/6767906449165630/019d2709-87d6-71c0-ad0e-ae3b3ae21583.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ms/flowood/202-e.-layfair-dr",
      "poi_directions_map_url": "https://maps.google.com/?cid=119709276499798027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "32.3313599",
      "poi_longitude": "-90.1053988",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 601-933-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b335-715e-b806-2daa84587596.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b335-715e-b806-2daa84587596",
        "storage_key": "property/6767906449165630/019d2709-b335-715e-b806-2daa84587596.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHz4FBecsKIYRC-gW5vNKqQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3b4b8674-dd40-4457-b12a-4808015a222e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Northpark",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_long_description": "People say this shopping center offers a nice selection of stores and a variety of clothing brands. They also highlight the clean and well-lit environment, and the helpful and friendly staff.\n\nOther reviews mention some stores can be vacant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-87b0-71fd-9aaf-a86f2275cc0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-87b0-71fd-9aaf-a86f2275cc0d",
        "storage_key": "property/6767906449165630/019d2709-87b0-71fd-9aaf-a86f2275cc0d.webp",
        "width": 1280,
        "height": 819
      },
      "poi_business_url": "http://www.visitnorthpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14074278564042696477&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northpark",
      "poi_latitude": "32.4030556",
      "poi_longitude": "-90.1291667",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-863-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b355-756a-b5a2-5919ec489900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b355-756a-b5a2-5919ec489900",
        "storage_key": "property/6767906449165630/019d2709-b355-756a-b5a2-5919ec489900.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhY9vW4rSKYYRHeeoB8nhUcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3d4424a3-2afa-4c80-9004-e02831698abc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4500 I-55, Jackson, MS 39211, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, seafood, and specialty items, including a hot bar and bakery. They highlight the clean, well-organized store and the calm, welcoming vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-8947-7428-9783-77180ca59298.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8947-7428-9783-77180ca59298",
        "storage_key": "property/6767906449165630/019d2709-8947-7428-9783-77180ca59298.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/jkn?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173301360047794626&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "32.354786",
      "poi_longitude": "-90.1495362",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-608-0405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b2e2-7267-bd02-7ad31689261b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b2e2-7267-bd02-7ad31689261b",
        "storage_key": "property/6767906449165630/019d2709-b2e2-7267-bd02-7ad31689261b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8w7oKoyKIYRwqnRtMr30LY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9b845421-2afc-4cb7-a470-eddec83ab6a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "4910 I-55, Jackson, MS 39211, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "People say this grocery store offers fresh produce and unique brands. They also highlight the helpful staff and the meat market with a butcher on hand.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-8909-7399-a3cb-3fb521465560.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8909-7399-a3cb-3fb521465560",
        "storage_key": "property/6767906449165630/019d2709-8909-7399-a3cb-3fb521465560.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ms/jackson/jacksonian-plaza/025/00345?cid=loc_02500345_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12562485936542992699&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.3637911",
      "poi_longitude": "-90.1479131",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-366-1141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b2e2-7267-bd02-7ad31689261b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b2e2-7267-bd02-7ad31689261b",
        "storage_key": "property/6767906449165630/019d2709-b2e2-7267-bd02-7ad31689261b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp_-AxKsyKIYRO0l8f2bqVq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d8c82779-16cb-4884-8044-09ab9c5c1085",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "120 Ridge Way, Flowood, MS 39232, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products. They also highlight the helpful staff and the well-stocked shelves.\n\nOther reviews mention delivery can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-8bfd-72f9-a3fb-fbc116931534.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8bfd-72f9-a3fb-fbc116931534",
        "storage_key": "property/6767906449165630/019d2709-8bfd-72f9-a3fb-fbc116931534.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/MS-Flowood/2553?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2553-_-na-_-0-_-0&y_source=1_MTE4MzYzNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9943658338956026944&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "32.3410494",
      "poi_longitude": "-90.0720381",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 601-992-8475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b355-756a-b5a2-5919ec489900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b355-756a-b5a2-5919ec489900",
        "storage_key": "property/6767906449165630/019d2709-b355-756a-b5a2-5919ec489900.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAeOQyEcrKIYRQCRTVZP4_ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_21fff842-23f5-478a-9b01-4f7205c75f61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Renaissance at Colony Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "Brand-name & upmarket boutiques in an elegant outdoor shopping plaza with cafes & play areas.",
      "poi_long_description": "People say this shopping center offers a wide variety of shops and restaurants. They highlight the clean and well-maintained environment, and the beautiful fountains and water show. They also like the safe and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-8c76-7099-bda7-1c4309049a2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8c76-7099-bda7-1c4309049a2e",
        "storage_key": "property/6767906449165630/019d2709-8c76-7099-bda7-1c4309049a2e.webp",
        "width": 701,
        "height": 396
      },
      "poi_business_url": "https://renaissanceatcolonypark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1390767190390103411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "renaissance-at-colony-park",
      "poi_latitude": "32.4356677",
      "poi_longitude": "-90.1465128",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-519-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b355-756a-b5a2-5919ec489900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b355-756a-b5a2-5919ec489900",
        "storage_key": "property/6767906449165630/019d2709-b355-756a-b5a2-5919ec489900.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr8vq_wjSKYYRc114HGT_TBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8ec7d3d8-599d-4eb6-8545-e8dfd016a5d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Holmes Community College",
      "poi_type": "Education",
      "poi_address": "412 W Ridgeland Ave, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-8d8e-764b-8600-c9c62fc56aac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8d8e-764b-8600-c9c62fc56aac",
        "storage_key": "property/6767906449165630/019d2709-8d8e-764b-8600-c9c62fc56aac.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://holmescc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907095702532732739&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "holmes-community-college",
      "poi_latitude": "32.4371517",
      "poi_longitude": "-90.1391745",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-605-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b318-77ae-942c-b412b111aa99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b318-77ae-942c-b412b111aa99",
        "storage_key": "property/6767906449165630/019d2709-b318-77ae-942c-b412b111aa99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5RKR5BrSKYYRQzcXM_Lu2l8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_52bfb1e7-2c82-4eea-b268-1f384274d31e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Tougaloo College",
      "poi_type": "Education",
      "poi_address": "500 W County Line Rd, Tougaloo, MS 39174, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-8ebb-7108-a2c7-8b9435bc9891.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8ebb-7108-a2c7-8b9435bc9891",
        "storage_key": "property/6767906449165630/019d2709-8ebb-7108-a2c7-8b9435bc9891.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tougaloo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11573720754771851030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tougaloo-college",
      "poi_latitude": "32.4048193",
      "poi_longitude": "-90.160845",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-977-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b318-77ae-942c-b412b111aa99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b318-77ae-942c-b412b111aa99",
        "storage_key": "property/6767906449165630/019d2709-b318-77ae-942c-b412b111aa99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJewwN-pzNKYYRFve9zbQdnqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d730477c-7b28-4a91-95de-6ac95716b0f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "6370 Ridgewood Ct Dr, Jackson, MS 39211, USA",
      "poi_short_description": "Trampoline park featuring multiple jumping areas, plus go-karts, arcade games and a zip line.",
      "poi_long_description": "People say this amusement park offers a variety of exciting activities, including trampolines, go-karts, bumper cars, and a zip line. They highlight the fun, family-friendly atmosphere and the spacious layout with plenty of activities for kids. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-9177-71b4-bb33-87ea82e2d135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9177-71b4-bb33-87ea82e2d135",
        "storage_key": "property/6767906449165630/019d2709-9177-71b4-bb33-87ea82e2d135.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/mississippi-jackson/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3514114226054270296&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "32.3958583",
      "poi_longitude": "-90.1364822",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-566-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9gZoZjTKYYRWI0cIEWkxDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_6b0f0721-06d1-4ccd-8dd3-ee0b11daa332",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "2000 E County Line Rd Suite B, Ridgeland, MS 39157, USA",
      "poi_short_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_long_description": "People say this amusement park is a fun place for kids and adults to have birthday parties. They also highlight the professional and attentive staff, and the good management.\n\nOther reviews mention the offerings can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-90b7-71cb-84a4-ef692d7e657a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-90b7-71cb-84a4-ef692d7e657a",
        "storage_key": "property/6767906449165630/019d2709-90b7-71cb-84a4-ef692d7e657a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.skyzone.com/ridgeland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15573673565696973962&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "32.400928",
      "poi_longitude": "-90.109942",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 601-899-0015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz8_ZewDTKYYRilxCW5jNINg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_63a1a571-53c7-42a1-888f-ddb54a79cf02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Mississippi Agriculture and Forestry Museum",
      "poi_type": "Entertainment",
      "poi_address": "1150 Lakeland Dr, Jackson, MS 39216, USA",
      "poi_short_description": "A living-history farm, a recreated 1920s cotton-economy-era town & local historical artifacts.",
      "poi_long_description": "Visitors say this museum features antique equipment, tools, cars, and planes, as well as a recreated old town with a doctor's office, gas station, and schoolhouse. They also highlight the special events, such as the Pickle Festival and pumpkin patch, that the museum hosts throughout the year.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-92b9-77fb-9930-c5cab6c22d5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-92b9-77fb-9930-c5cab6c22d5b",
        "storage_key": "property/6767906449165630/019d2709-92b9-77fb-9930-c5cab6c22d5b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.msagmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7687106239260140894&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mississippi-agriculture-and-forestry-museum",
      "poi_latitude": "32.3366165",
      "poi_longitude": "-90.1577225",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 601-432-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b738-742a-b548-c705bf28f743.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b738-742a-b548-c705bf28f743",
        "storage_key": "property/6767906449165630/019d2709-b738-742a-b548-c705bf28f743.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yEzu6IyKIYRXiXKhWUWrmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b73895e4-96a6-46d2-a1ae-8807174f84d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "DEFY Jackson",
      "poi_type": "Entertainment",
      "poi_address": "2280 Lakeland Dr, Jackson, MS 39232, USA",
      "poi_short_description": "Kid-friendly bounce center with a ninja-style obstacle course, dodgeball and foam pits.",
      "poi_long_description": "People say this amusement park offers fun activities for kids, including jumping. They also highlight the organized party booking process and helpful staff.\n\nOther reviews mention the membership can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-9410-749d-9595-eb1b1f7b99dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9410-749d-9595-eb1b1f7b99dd",
        "storage_key": "property/6767906449165630/019d2709-9410-749d-9595-eb1b1f7b99dd.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://defy.com/defy-jackson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10670914183626614326&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "defy-jackson",
      "poi_latitude": "32.3315296",
      "poi_longitude": "-90.12563",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 769-208-3008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQRfI-xUtKIYRNua9v-mzFpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_67131b76-53a6-43c4-aa06-ffd8b6e2aa5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Smith-Wills Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1200 Lakeland Dr, Jackson, MS 39216, USA",
      "poi_short_description": "Stadium hosting fireworks displays, games and concerts, plus other events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-956c-7758-9811-758a22137f8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-956c-7758-9811-758a22137f8a",
        "storage_key": "property/6767906449165630/019d2709-956c-7758-9811-758a22137f8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=385897145946479173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "smith-wills-stadium",
      "poi_latitude": "32.336819",
      "poi_longitude": "-90.153487",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-362-2294",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b741-73cd-b9bf-8f8a446eb22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b741-73cd-b9bf-8f8a446eb22e",
        "storage_key": "property/6767906449165630/019d2709-b741-73cd-b9bf-8f8a446eb22e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd5hrcKEyKIYRRRr632j7WgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_0f195528-9420-4da0-a37e-ce78f8a8f3ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "772 Lake Harbour Dr Ste 1, Ridgeland, MS 39157, USA",
      "poi_short_description": "Clean gym chain featuring a cardio area, weight machines and a 24-hour schedule.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-9756-7648-ae12-13e9b100b651.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9756-7648-ae12-13e9b100b651",
        "storage_key": "property/6767906449165630/019d2709-9756-7648-ae12-13e9b100b651.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/ridgeland-ms?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17295786995903098070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.41556",
      "poi_longitude": "-90.11079",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-427-5901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSGVmpnTKYYR1uyfwaL6BvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d825484d-5baa-4073-8f5b-36282b5e3b9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "GRIT Training",
      "poi_type": "Health and Wellness",
      "poi_address": "2625 Courthouse Cir, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.grit-ms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2231842918902481768&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grit-training",
      "poi_latitude": "32.3272575",
      "poi_longitude": "-90.1152147",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 601-487-2443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo6cx-GwtKIYRaEOnV08Z-R4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_047ff79d-a6da-43f4-bb47-1537ca4ad700",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Animal Emergency & Referral Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1009 Treetops Blvd, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-9825-7759-b62e-7ea27452705a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9825-7759-b62e-7ea27452705a",
        "storage_key": "property/6767906449165630/019d2709-9825-7759-b62e-7ea27452705a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cvm.msstate.edu/aerc-home",
      "poi_directions_map_url": "https://maps.google.com/?cid=12162414471896174386&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-emergency--referral-center",
      "poi_latitude": "32.3255648",
      "poi_longitude": "-90.1194963",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 601-939-8999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzq8QxotKIYRMg9x4IWTyag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_3cf48739-ccd6-4392-bb9c-18ac58aea544",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "CLUB4 Fitness Lake Harbour",
      "poi_type": "Health and Wellness",
      "poi_address": "511 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Membership-only gym offering equipment, classes, child care, a pool, and a rock climbing wall.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, classes, and training options, including a women's-only area and a pool. They also highlight the friendly staff, clean facility, and reasonable membership prices.\n\nSome reviews mention the equipment can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-9899-77c7-ba88-97bd878a5aa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9899-77c7-ba88-97bd878a5aa8",
        "storage_key": "property/6767906449165630/019d2709-9899-77c7-ba88-97bd878a5aa8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.club4fitness.com/location/lake-harbour/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6318120847339163222&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "club4-fitness-lake-harbour",
      "poi_latitude": "32.4133465",
      "poi_longitude": "-90.1175495",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-605-9886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSTFhXUPSKYYRVg6kkW95rlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6989a269-aaf2-419f-9114-4d34dc896b10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Ancee Nail Lounge",
      "poi_type": "Health and Wellness",
      "poi_address": "1855 Lakeland Dr # E10, Jackson, MS 39216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-9ac4-7288-874a-91b785bd710d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9ac4-7288-874a-91b785bd710d",
        "storage_key": "property/6767906449165630/019d2709-9ac4-7288-874a-91b785bd710d.webp",
        "width": 1280,
        "height": 1202
      },
      "poi_business_url": "https://anceenaillounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11516596813459570638&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ancee-nail-lounge",
      "poi_latitude": "32.3331343",
      "poi_longitude": "-90.1396647",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-368-6868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR1nZRQwtKIYRzj-nx8gr058",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_fc9507e9-5084-4d94-b04f-2d0b200229c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Flowood - Lakeland Drive",
      "poi_type": "Health and Wellness",
      "poi_address": "163 Ridge Way E, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-9c9b-7451-b4e9-058ddcbac7ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9c9b-7451-b4e9-058ddcbac7ef",
        "storage_key": "property/6767906449165630/019d2709-9c9b-7451-b4e9-058ddcbac7ef.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-ms-flowood-ms101?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=9886910044159362539&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-flowood---lakeland-drive",
      "poi_latitude": "32.3395694",
      "poi_longitude": "-90.0703666",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 601-992-2733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfbKwFsrKIYR60VcVE1cNYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_93741793-9621-494e-b8e6-52039c3331b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Crunch Fitness - Ridgeland",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Chain gym offering group fitness classes and personal training in Ridgeland, MS.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-9d0d-719d-9e61-860bfd3ea242.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9d0d-719d-9e61-860bfd3ea242",
        "storage_key": "property/6767906449165630/019d2709-9d0d-719d-9e61-860bfd3ea242.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.crunch.com/locations/ridgeland",
      "poi_directions_map_url": "https://maps.google.com/?cid=16000032341730509397&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---ridgeland",
      "poi_latitude": "32.4010391",
      "poi_longitude": "-90.1096038",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 601-360-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfpJ8fjSKYYRVcKbm6SIC94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_86c63e3a-7121-4030-83f4-347cd3ee173d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Courthouse Gymnastics Cou",
      "poi_type": "Health and Wellness",
      "poi_address": "698 Liberty Rd, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-9d37-774a-98d8-5528ce79b57c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9d37-774a-98d8-5528ce79b57c",
        "storage_key": "property/6767906449165630/019d2709-9d37-774a-98d8-5528ce79b57c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.courthousegymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10353510153888683355&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "courthouse-gymnastics-cou",
      "poi_latitude": "32.3435763",
      "poi_longitude": "-90.0878897",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-932-6680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b318-77ae-942c-b412b111aa99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b318-77ae-942c-b412b111aa99",
        "storage_key": "property/6767906449165630/019d2709-b318-77ae-942c-b412b111aa99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhS3gP_osKIYRW1XvNKEOr48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1d65b849-89ac-4161-abc1-9b0f4a1bae9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Madison Healthplex Performance Training Center",
      "poi_type": "Health and Wellness",
      "poi_address": "501 Baptist Dr, Madison, MS 39110, USA",
      "poi_short_description": "Large gym with a pool, hot tub, and cold plunge, plus a variety of group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-a02f-76e9-bad1-7b4c38b3b374.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a02f-76e9-bad1-7b4c38b3b374",
        "storage_key": "property/6767906449165630/019d2709-a02f-76e9-bad1-7b4c38b3b374.webp",
        "width": 981,
        "height": 768
      },
      "poi_business_url": "http://www.healthplexperformance.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10695343614279382681&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "madison-healthplex-performance-training-center",
      "poi_latitude": "32.470621",
      "poi_longitude": "-90.1372865",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-856-7757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV0v5kMLRKYYRmXbdz1l-bZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5c654870-3c42-42aa-9738-af0223c1c58a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "St. Dominic Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "969 Lakeland Dr, Jackson, MS 39216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-a09d-74d8-a303-366d4b5d0487.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a09d-74d8-a303-366d4b5d0487",
        "storage_key": "property/6767906449165630/019d2709-a09d-74d8-a303-366d4b5d0487.webp",
        "width": 448,
        "height": 278
      },
      "poi_business_url": "https://www.fmolhs.org/locations/greater-jackson/st-dominics-hospital?utm_source=Google&utm_medium=listing&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=2322937810740476467&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-dominic-hospital",
      "poi_latitude": "32.3364828",
      "poi_longitude": "-90.1636614",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-200-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b73a-72e7-9499-edf2e298902c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b73a-72e7-9499-edf2e298902c",
        "storage_key": "property/6767906449165630/019d2709-b73a-72e7-9499-edf2e298902c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJXYdRlJUyKIYRM3qCpKG7PCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_606ac6cf-a269-4dc9-8d9a-226c6ca26876",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Merit Health River Oaks",
      "poi_type": "Health and Wellness",
      "poi_address": "1030 River Oaks Dr, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-a25c-76d9-a82b-d22765f41525.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a25c-76d9-a82b-d22765f41525",
        "storage_key": "property/6767906449165630/019d2709-a25c-76d9-a82b-d22765f41525.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.merithealthriveroaks.com/?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11758755380568636959&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "merit-health-river-oaks",
      "poi_latitude": "32.3255013",
      "poi_longitude": "-90.1052711",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 601-932-1030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b73a-72e7-9499-edf2e298902c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b73a-72e7-9499-edf2e298902c",
        "storage_key": "property/6767906449165630/019d2709-b73a-72e7-9499-edf2e298902c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdk8UuQsKIYRH76B07d9L6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_c74dbee1-83d6-4f43-9e63-e82b05b2d053",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "LeFleur's Bluff State Park Mayes Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3315 Lakeland Terrace, Jackson, MS 39216, USA",
      "poi_short_description": "A 305-acre park of lakes, forests & fields that offers camping, fishing & a 9-hole golf course.",
      "poi_long_description": "People say this state park offers fishing, camping, walking trails, picnic tables, and pavilions. They highlight the beautiful views, the escape to nature, and the affordable prices, including military discounts. They also like the clean restrooms and shower facilities, and the availability of laundry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-a28c-766b-96e0-7bb286ec9894.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a28c-766b-96e0-7bb286ec9894",
        "storage_key": "property/6767906449165630/019d2709-a28c-766b-96e0-7bb286ec9894.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mdwfp.com/parks-destinations/park/lefleurs-bluff-state-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18333674287180082174&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lefleurs-bluff-state-park-mayes-lake",
      "poi_latitude": "32.3308055",
      "poi_longitude": "-90.1489668",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 601-987-3923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-bb46-7509-9445-5c498dcaa44c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bb46-7509-9445-5c498dcaa44c",
        "storage_key": "property/6767906449165630/019d2709-bb46-7509-9445-5c498dcaa44c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNTspAmItKIYR_usU06BLbv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_1bef0669-e195-4167-9313-a8eb52293f9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Freedom Ridge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "253 W School St, Ridgeland, MS 39157, USA",
      "poi_short_description": "Baseball, softball & soccer fields plus 2 playgrounds, 1 for children with varying abilities.",
      "poi_long_description": "People say this park is well-maintained and clean. They highlight the spaciousness, fun playgrounds for different age groups, and soccer fields. They also like the safe and friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-a4b0-7364-95f4-92840a53a442.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a4b0-7364-95f4-92840a53a442",
        "storage_key": "property/6767906449165630/019d2709-a4b0-7364-95f4-92840a53a442.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridgelandms.org/city-departments/recreation-and-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15546985984956168474&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "freedom-ridge",
      "poi_latitude": "32.4197477",
      "poi_longitude": "-90.1413081",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-853-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-bb46-7509-9445-5c498dcaa44c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bb46-7509-9445-5c498dcaa44c",
        "storage_key": "property/6767906449165630/019d2709-bb46-7509-9445-5c498dcaa44c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSKa83HSKYYRGvlJwWH9wdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_db71724e-ab7b-4274-82b4-e3f3b763f6ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Winners Circle Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Winners Cir, Flowood, MS 39232, USA",
      "poi_short_description": "Landscaped park with an amphitheater, open air pavilions, a playground & lit tennis courts.",
      "poi_long_description": "Visitors say this park has a great playground for kids of all ages, with a nearby Sonic for a convenient outing. They also highlight that the park is clean, safe, and well-maintained, making it a great place for families to enjoy the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-a50b-762e-bd01-c028b79b3238.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a50b-762e-bd01-c028b79b3238",
        "storage_key": "property/6767906449165630/019d2709-a50b-762e-bd01-c028b79b3238.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.cityofflowood.com/winner%E2%80%99s-circle-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4454325228718501489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winners-circle-park",
      "poi_latitude": "32.3470087",
      "poi_longitude": "-90.0625008",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-992-4440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-bb46-7509-9445-5c498dcaa44c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bb46-7509-9445-5c498dcaa44c",
        "storage_key": "property/6767906449165630/019d2709-bb46-7509-9445-5c498dcaa44c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9jH-04rKIYRca7TCzLx0D0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_51c903b5-387a-488c-98d1-6aba7eea356b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Old Trace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "422 Post Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Recreation area with picnic tables & reservoir views, plus an annual show by the local symphony.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park, a recreation center, a playground, and accessible swimming. They highlight the spaciousness, beautiful views of the reservoir, and the peaceful vibe, especially around sunset. They also like the convenient parking and the availability of gazebos for picnics and relaxation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-a6d5-7682-bc60-48ca4fe8f079.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a6d5-7682-bc60-48ca4fe8f079",
        "storage_key": "property/6767906449165630/019d2709-a6d5-7682-bc60-48ca4fe8f079.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.therez.ms.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=2671602723425758356&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-trace-park",
      "poi_latitude": "32.4274039",
      "poi_longitude": "-90.0823689",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-856-6574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-bb46-7509-9445-5c498dcaa44c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bb46-7509-9445-5c498dcaa44c",
        "storage_key": "property/6767906449165630/019d2709-bb46-7509-9445-5c498dcaa44c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCfITFPPTKYYRlCzCroVwEyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_564adff9-9bf3-44e0-b1a9-b0b14d2a8b96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Flowood Liberty Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Unnamed Road, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-a793-7408-b9e3-2e7532c7237f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a793-7408-b9e3-2e7532c7237f",
        "storage_key": "property/6767906449165630/019d2709-a793-7408-b9e3-2e7532c7237f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8220269399056143777&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flowood-liberty-park",
      "poi_latitude": "32.3464135",
      "poi_longitude": "-90.0864976",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-bb46-7509-9445-5c498dcaa44c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bb46-7509-9445-5c498dcaa44c",
        "storage_key": "property/6767906449165630/019d2709-bb46-7509-9445-5c498dcaa44c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0z5Z5wtKIYRoVXBMHdDFHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_db0e3733-9304-41b7-b885-25a042e8197d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Bruce Campbell Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "7450 Old Canton Rd, Madison, MS 39110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-a9bb-735f-9f95-6a3fb31d047d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a9bb-735f-9f95-6a3fb31d047d",
        "storage_key": "property/6767906449165630/019d2709-a9bb-735f-9f95-6a3fb31d047d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.madisonthecity.com/government/airport/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9202379395653693271&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bruce-campbell-field",
      "poi_latitude": "32.4400825",
      "poi_longitude": "-90.1052932",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-853-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-baff-7688-b9a0-bb84a9a19d87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-baff-7688-b9a0-bb84a9a19d87",
        "storage_key": "property/6767906449165630/019d2709-baff-7688-b9a0-bb84a9a19d87.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJfRqzhNDTKYYRV-9P1k1rtX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_a8b073ed-ea5d-4f08-83b6-8d6cdd601811",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Madison Air LLC.",
      "poi_type": "Transportation & Transit",
      "poi_address": "7450 Old Canton Rd, Madison, MS 39110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-aa5b-7649-ac9d-fcfc4c5fb353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-aa5b-7649-ac9d-fcfc4c5fb353",
        "storage_key": "property/6767906449165630/019d2709-aa5b-7649-ac9d-fcfc4c5fb353.webp",
        "width": 1280,
        "height": 761
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11203969235679198100&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "madison-air-llc",
      "poi_latitude": "32.4401776",
      "poi_longitude": "-90.1051652",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-853-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-baff-7688-b9a0-bb84a9a19d87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-baff-7688-b9a0-bb84a9a19d87",
        "storage_key": "property/6767906449165630/019d2709-baff-7688-b9a0-bb84a9a19d87.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYe6J9HTKYYRlDsQn6h-fJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_9a83ae95-d426-4828-be93-c99420c84500",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "The Powerhouse, Entergy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1350 Echelon Pkwy, Jackson, MS 39213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-abef-73fe-a872-0e7614cc9c55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-abef-73fe-a872-0e7614cc9c55",
        "storage_key": "property/6767906449165630/019d2709-abef-73fe-a872-0e7614cc9c55.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8770278893550025776&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-powerhouse-entergy",
      "poi_latitude": "32.396321",
      "poi_longitude": "-90.191046",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-952-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKaisuv7MKYYRMLwnzy9Ktnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0d1937bb-1f6a-479e-be79-ed656c692dce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Entergy Transmission HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6540 Watkins Dr, Jackson, MS 39213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-ad05-7653-bda1-28a7e338511f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ad05-7653-bda1-28a7e338511f",
        "storage_key": "property/6767906449165630/019d2709-ad05-7653-bda1-28a7e338511f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://entergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1578563261303676078&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "entergy-transmission-hq",
      "poi_latitude": "32.3975051",
      "poi_longitude": "-90.1912372",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2H9zv7MKYYRrtx8Lewu6BU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0739853e-7edc-477d-91a2-1ebaf19651f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "C Spire Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1018 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-aee0-7781-8b4a-eedf54f7f794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-aee0-7781-8b4a-eedf54f7f794",
        "storage_key": "property/6767906449165630/019d2709-aee0-7781-8b4a-eedf54f7f794.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cspire.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8383002471184058399&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "c-spire-corporate-headquarters",
      "poi_latitude": "32.437348",
      "poi_longitude": "-90.147231",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 866-455-9628",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv0s2rPXTKYYRH8glHlVoVnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3bb089f2-bed5-4c8c-a2e0-564592de5233",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "MDHS- Child Support Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "950 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mdhs.ms.gov/child-support/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1738695405663311359&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mdhs--child-support-services",
      "poi_latitude": "32.4004974",
      "poi_longitude": "-90.1374969",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-359-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu1njEqnTKYYR_1Uqa0IWIRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_aa017031-48f0-4c9b-826a-92a87f996893",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Cal-Maine Foods, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1052 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://calmainefoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17133107250284266322&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cal-maine-foods-inc",
      "poi_latitude": "32.4102297",
      "poi_longitude": "-90.1139188",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 601-948-6813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-b720-75cb-8c74-188486593d3d",
        "storage_key": "property/6767906449165630/019d2709-b720-75cb-8c74-188486593d3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZm8XmIzKIYRUgPd30QGxe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_16f45a56-287c-47c0-8270-82fc2dc105ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Ann Smith Elementary School",
      "poi_type": "Education",
      "poi_address": "306 S Pear Orchard Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-2d4d-7668-8fbc-d0b49e3086be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2d4d-7668-8fbc-d0b49e3086be",
        "storage_key": "property/6767906449165630/019d7913-2d4d-7668-8fbc-d0b49e3086be.webp",
        "width": 533,
        "height": 400
      },
      "poi_business_url": "http://www.madison-schools.com/ase",
      "poi_directions_map_url": "https://maps.google.com/?cid=2820663062739685371&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ann-smith-elementary-school",
      "poi_latitude": "32.420476",
      "poi_longitude": "-90.1220605",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-856-6621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a494-779c-a8d7-84680c849275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a494-779c-a8d7-84680c849275",
        "storage_key": "property/6767906449165630/019cfb48-a494-779c-a8d7-84680c849275.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6yCSN0bSKYYR-w-qbRwCJSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a66d8cef-4bce-4d0e-b418-7bb232b36406",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Highland Elementary School",
      "poi_type": "Education",
      "poi_address": "330 Brame Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.madison-schools.com/hes",
      "poi_directions_map_url": "https://maps.google.com/?cid=15494384500546725945&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "highland-elementary-school",
      "poi_latitude": "32.4161238",
      "poi_longitude": "-90.1505377",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-853-8103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a494-779c-a8d7-84680c849275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a494-779c-a8d7-84680c849275",
        "storage_key": "property/6767906449165630/019cfb48-a494-779c-a8d7-84680c849275.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJddIAM4rNKYYROehnSJwcB9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d8de8c99-83ab-4d51-b698-290fef5d1a69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Old Town Middle School",
      "poi_type": "Education",
      "poi_address": "210 Sunnybrook Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.madison-schools.com/otm",
      "poi_directions_map_url": "https://maps.google.com/?cid=4526077922393244761&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-town-middle-school",
      "poi_latitude": "32.4317835",
      "poi_longitude": "-90.1395532",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-898-8730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a494-779c-a8d7-84680c849275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a494-779c-a8d7-84680c849275",
        "storage_key": "property/6767906449165630/019cfb48-a494-779c-a8d7-84680c849275.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyawiLQ7SKYYRWcT85ePbzz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_61609e28-ddcb-4213-8fe2-da3abd796310",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Ridgeland High School",
      "poi_type": "Education",
      "poi_address": "586 Sunnybrook Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-2bff-706e-b5ba-2799d32aeae5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2bff-706e-b5ba-2799d32aeae5",
        "storage_key": "property/6767906449165630/019d7913-2bff-706e-b5ba-2799d32aeae5.webp",
        "width": 440,
        "height": 400
      },
      "poi_business_url": "https://rhs.madison-schools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3513983871240866136&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ridgeland-high-school",
      "poi_latitude": "32.4445543",
      "poi_longitude": "-90.1360819",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-898-5023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a494-779c-a8d7-84680c849275.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a494-779c-a8d7-84680c849275",
        "storage_key": "property/6767906449165630/019cfb48-a494-779c-a8d7-84680c849275.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOYANuB3SKYYRWInDh7YtxDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ba973482-4aa6-4485-98f8-e06899572cb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Kathryn's Steakhouse and Seafood Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6800 Old Canton Rd #108, Ridgeland, MS 39157, USA",
      "poi_short_description": "Relaxed bar/eatery since 1991 offering steak & seafood dishes, plus live music & TVs showing sports.",
      "poi_long_description": "People say this steakhouse serves delicious steak, prime rib, and filet, and offers a variety of other dishes like pasta Bolognese and stuffed redfish. They also highlight the great service, comfortable seating, and lively atmosphere with live music in the bar area.\n\nSome reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-4005-7218-bd3e-008e174f3240.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4005-7218-bd3e-008e174f3240",
        "storage_key": "property/6767906449165630/019d7913-4005-7218-bd3e-008e174f3240.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.kathrynssteaks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13077272740773673135&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kathryn-s-steakhouse-and-seafood-restaurant",
      "poi_latitude": "32.4100512",
      "poi_longitude": "-90.1057078",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 601-956-2803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a493-7208-bd7b-ee24b8b444ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a493-7208-bd7b-ee24b8b444ba",
        "storage_key": "property/6767906449165630/019cfb48-a493-7208-bd7b-ee24b8b444ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUo8Fa7TKYYRr7i2eEXOe7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_7682b7ba-079a-4e60-9806-9b10e8a0fb5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Sal and Phil's",
      "poi_type": "Restaurants",
      "poi_address": "6600 Old Canton Rd Ste B, Ridgeland, MS 39157, USA",
      "poi_short_description": "Casual eatery & bar featuring po' boys, muffuletta, seafood platters & more, plus sports on TV.",
      "poi_long_description": "People say this seafood restaurant serves delicious fried catfish, shrimp, and charbroiled oysters. They also highlight the good value and attentive service.\n\nSome reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-2ab5-762d-a27b-4d644a99a98e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2ab5-762d-a27b-4d644a99a98e",
        "storage_key": "property/6767906449165630/019d7913-2ab5-762d-a27b-4d644a99a98e.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://salandphils.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14720075100903259829&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sal-and-phil-s",
      "poi_latitude": "32.402629",
      "poi_longitude": "-90.107418",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 601-957-1188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a493-7208-bd7b-ee24b8b444ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a493-7208-bd7b-ee24b8b444ba",
        "storage_key": "property/6767906449165630/019cfb48-a493-7208-bd7b-ee24b8b444ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_9RIYPLTKYYRtT5pYFA2SMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_e6f0f48b-a267-4bb9-937e-70094bf41b29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Amerigo Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6592 Old Canton Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Local chain outlet with a full bar & a menu of classic Italian dishes in an easygoing atmosphere.",
      "poi_long_description": "People say this Italian restaurant serves delicious veal saltimbocca, chicken piccata, and redfish. They highlight the reasonable prices and generous portions. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-3133-7758-b012-58b2c1baaae0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3133-7758-b012-58b2c1baaae0",
        "storage_key": "property/6767906449165630/019d7913-3133-7758-b012-58b2c1baaae0.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://www.amerigo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3134931430254947506&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amerigo-italian-restaurant",
      "poi_latitude": "32.402115",
      "poi_longitude": "-90.1075574",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 601-977-0563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a493-7208-bd7b-ee24b8b444ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a493-7208-bd7b-ee24b8b444ba",
        "storage_key": "property/6767906449165630/019cfb48-a493-7208-bd7b-ee24b8b444ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP94qGKrTKYYRsqyNt4aDgSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_5378e944-031f-44d0-9c3e-8e6dd7019094",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Bulldog Burger Company Ridgeland",
      "poi_type": "Restaurants",
      "poi_address": "879 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Burgers and comfort fare served in a laid-back restaurant with happy-hour specials.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, fried pickles, and shakes. They also highlight the friendly service, chill vibe, and dog-friendly atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-344b-752a-a8fc-243f026fc2f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-344b-752a-a8fc-243f026fc2f8",
        "storage_key": "property/6767906449165630/019d7913-344b-752a-a8fc-243f026fc2f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bulldogburgerco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15535949085311012215&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bulldog-burger-company-ridgeland",
      "poi_latitude": "32.4131032",
      "poi_longitude": "-90.103412",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-899-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a493-7208-bd7b-ee24b8b444ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a493-7208-bd7b-ee24b8b444ba",
        "storage_key": "property/6767906449165630/019cfb48-a493-7208-bd7b-ee24b8b444ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHypctLzTKYYRd42ETmHHmtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_6fa4f78b-3e32-4f2b-a462-787b64ebf483",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "McB's Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "815 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Laid-back eatery featuring burgers and other comfort grub, plus live music, karaoke and a patio.",
      "poi_long_description": "People say this bar and grill offers delicious burgers, fried mushrooms, and French dip sandwiches. They also highlight the fun atmosphere, live music, and friendly service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-4539-76ba-8fd7-82a6289b9771.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4539-76ba-8fd7-82a6289b9771",
        "storage_key": "property/6767906449165630/019d7913-4539-76ba-8fd7-82a6289b9771.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://eatmcbs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=407587837965926526&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mcb-s-bar-grill",
      "poi_latitude": "32.4135971",
      "poi_longitude": "-90.1049427",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 601-956-8362",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-6b43-7177-916c-9d46f2e8dbb0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-6b43-7177-916c-9d46f2e8dbb0",
        "storage_key": "property/6767906449165630/019d7913-6b43-7177-916c-9d46f2e8dbb0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwjzy7HTKYYRfoC6qPoKqAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_aebf4e7a-dba1-4025-9026-311945f05712",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "County Line Plaza",
      "poi_type": "Restaurants",
      "poi_address": "1053 E County Line Rd, Jackson, MS 39211, USA",
      "poi_short_description": "Shopping mall featuring a variety of stores.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-3b9b-7649-a620-b3741afe6ee6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3b9b-7649-a620-b3741afe6ee6",
        "storage_key": "property/6767906449165630/019d7913-3b9b-7649-a620-b3741afe6ee6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12140557239218336671&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "county-line-plaza",
      "poi_latitude": "32.3985977",
      "poi_longitude": "-90.1381977",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-360-8436",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a495-724a-9ff8-90167487368a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a495-724a-9ff8-90167487368a",
        "storage_key": "property/6767906449165630/019cfb48-a495-724a-9ff8-90167487368a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXX707YjSKYYRn_PnUnzse6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e0b3e407-da08-411e-a507-ab15aa8d4da2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Tuxedo Junction",
      "poi_type": "Restaurants",
      "poi_address": "Trace Station, 500 US-51 Suite K, Ridgeland, MS 39157, USA",
      "poi_short_description": "Men's formalwear rental chain, with tuxedos, suits & accessories for weddings, proms & other events.",
      "poi_long_description": "Men's formalwear rental chain, with tuxedos, suits & accessories for weddings, proms & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-40c9-74ce-a103-0fcd31fbcc20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-40c9-74ce-a103-0fcd31fbcc20",
        "storage_key": "property/6767906449165630/019d7913-40c9-74ce-a103-0fcd31fbcc20.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tuxedojunction.com/tjmississippi",
      "poi_directions_map_url": "https://maps.google.com/?cid=4676158821948477655&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tuxedo-junction",
      "poi_latitude": "32.4296292",
      "poi_longitude": "-90.1267226",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-957-1233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a495-724a-9ff8-90167487368a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a495-724a-9ff8-90167487368a",
        "storage_key": "property/6767906449165630/019cfb48-a495-724a-9ff8-90167487368a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhxX6Q4rSKYYR11CMV6wN5UA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_0b3eb5b0-8032-49a8-96de-327b13efccad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Enter/Locked Escape Rooms",
      "poi_type": "Entertainment",
      "poi_address": "6718 Old Canton Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Escape-game center offering five themed rooms for private group challenges.",
      "poi_long_description": "People say this amusement center offers fun and challenging escape rooms with clever puzzles. They highlight the immersive experience, unique themes, and interactive rooms. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-4b9c-7456-b3c9-6d8e96638705.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4b9c-7456-b3c9-6d8e96638705",
        "storage_key": "property/6767906449165630/019d7913-4b9c-7456-b3c9-6d8e96638705.webp",
        "width": 1241,
        "height": 650
      },
      "poi_business_url": "https://www.enterlocked.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8297131859657073285&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "enter-locked-escape-rooms",
      "poi_latitude": "32.408895",
      "poi_longitude": "-90.1058825",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 601-665-3299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a463-75ad-93cf-a9f9684ca1c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a463-75ad-93cf-a9f9684ca1c9",
        "storage_key": "property/6767906449165630/019cfb48-a463-75ad-93cf-a9f9684ca1c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZY297q7TKYYRhaJvXXdVJXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_e2d0b9a9-6f3d-42e2-addf-1635a0fa4291",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Old Trace",
      "poi_type": "Entertainment",
      "poi_address": "Unnamed Road #39157, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-4f50-757e-a76e-68b42bbd9c4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4f50-757e-a76e-68b42bbd9c4c",
        "storage_key": "property/6767906449165630/019d7913-4f50-757e-a76e-68b42bbd9c4c.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://npplan.com/parks-by-state/mississippi-national-parks/natchez-trace-parkway-park-at-a-glance/natchez-trace-parkway-hiking-trails/natchez-trace-parkway-old-trace-and-brashears-stand-mp-104-5/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14989083696698533799&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-trace",
      "poi_latitude": "32.424649",
      "poi_longitude": "-90.0890086",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-856-6574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a48f-70d9-bd42-25b577b87aee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a48f-70d9-bd42-25b577b87aee",
        "storage_key": "property/6767906449165630/019cfb48-a48f-70d9-bd42-25b577b87aee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1XPJUOvTKYYRp6dQ4jTsA9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5e3a22cb-6e9d-49bd-a7f7-138b1bdf7f0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Malco Renaissance Cinema Grill",
      "poi_type": "Entertainment",
      "poi_address": "1000 Highland Colony Pkwy Suite 13000, Ridgeland, MS 39157, USA",
      "poi_short_description": "Cinema chain offering multiple screens of mainstream films with standard amenities & refreshments.",
      "poi_long_description": "People say this movie theater offers comfortable seating and tasty food, especially the funnel cake fries. They also highlight the beautiful facilities, great location, and the availability of a full bar.\n\nSome reviews mention the service can be subpar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-52ac-7126-94e6-c4d3974c1b8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-52ac-7126-94e6-c4d3974c1b8a",
        "storage_key": "property/6767906449165630/019d7913-52ac-7126-94e6-c4d3974c1b8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://malco.com/cinemas/renaissance-cinema-grill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7713216517243925973&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "malco-renaissance-cinema-grill",
      "poi_latitude": "32.4364867",
      "poi_longitude": "-90.14694260000002",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-521-1171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-6c6a-70cd-9dfc-f9e9f3d77f4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-6c6a-70cd-9dfc-f9e9f3d77f4d",
        "storage_key": "property/6767906449165630/019d7913-6c6a-70cd-9dfc-f9e9f3d77f4d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJy1g7cfHTKYYR1fX_WY7ZCms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_c780efa9-4a00-48a2-8842-7694577dd06e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "The Country Club of Jackson",
      "poi_type": "Entertainment",
      "poi_address": "345 St Andrews Dr, Jackson, MS 39211, USA",
      "poi_short_description": "Members-only country club with a golf course, tennis courts, and croquet, plus wedding and banquet facilities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019d7913-58e8-7665-87e4-af3de742e0d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-58e8-7665-87e4-af3de742e0d4",
        "storage_key": "property/6767906449165630/019d7913-58e8-7665-87e4-af3de742e0d4.webp",
        "width": 640,
        "height": 352
      },
      "poi_business_url": "http://www.ccjackson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9676127438248580849&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-country-club-of-jackson",
      "poi_latitude": "32.396867",
      "poi_longitude": "-90.0987004",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-956-1411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-a463-75ad-93cf-a9f9684ca1c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb48-a463-75ad-93cf-a9f9684ca1c9",
        "storage_key": "property/6767906449165630/019cfb48-a463-75ad-93cf-a9f9684ca1c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM1aQVQvTKYYR8ZY3hqOCSIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_d31544b0-7106-4096-9e9f-ea721c74b1d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Sambou’s African Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "sambou-s-african-kitchen",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9c0ecfd1-ab46-4088-90c3-f74ca8784522",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "poi_name": "Reservoir Outlook",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "reservoir-outlook",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_4ce1f347c0889b97aa057bc8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f45fb0b902c3c9c58dc06f0e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_87a7cda71a5cb38bb4a1a96c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_47b4534b82158c9b1bae990b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e7fe8fa7d5babaed09f11456",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_2550d5f2b5f92304289a6539",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a571ed1c-e7cb-496e-bbf9-96cbb4de042f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "rating": "5.0",
      "name": "Imranali Md",
      "text": "I’m currently living here and really enjoying it. The apartment is comfortable and well-maintained. The staff is friendly, professional, and always helpful. A great place to call home.",
      "date": "2025-10-11",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_20adb652-905b-4d6f-97fd-2e87d11b8b07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-fa5d-71dd-806e-b261e92f0e03.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with fireplace and dining area.",
        "public_id": "019cfb48-fa5d-71dd-806e-b261e92f0e03",
        "storage_key": "property/6767906449165630/019cfb48-fa5d-71dd-806e-b261e92f0e03.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Sunchase Ridgeland Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6334c0066578507ebe66e0ff"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-828d-759e-99a5-f03d32ff1c81",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "sunchase-ridgeland-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630"
    },
    {
      "lead_collector_id": "019cf79e-82ff-7639-921c-ac7cd2b4ac53",
      "lead_source": "LANDING_PAGE",
      "name": "sunchase-ridgeland-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "apartments-with-pool-ridgeland-ms",
      "search_query": "apartments with pool in Ridgeland MS",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Ridgeland, MS",
      "h2_subtitle": "Discover top-notch apartments with a pool in Ridgeland, MS. Enjoy modern living with conveniences and amenities at Sunchase Ridgeland Apts.",
      "page_copy": "Sunchase Ridgeland Apts. offers a serene setting with the perfect blend of comfort and recreation. If you're searching for apartments with a pool in Ridgeland, MS, you've found the right place! Our community's refreshing pool provides an ideal spot to relax and unwind, adding a touch of luxury to everyday life. Our beautifully designed one and two-bedroom residences come with inviting eat-in kitchens and generous walk-in closets, ready to suit your lifestyle.\n\nBeyond our exceptional pool area, Sunchase Ridgeland Apts. features a state-of-the-art fitness center and on-site management services, ensuring all your needs are met with ease. Additionally, the clubhouse is perfect for social gatherings or quiet downtime. Dive into a community that prioritizes your comfort and leisure in a convenient Ridgeland location. Schedule a tour today and experience the charm of our poolside living firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Ridgeland, MS",
      "seo_description": "Find apartments with a pool in Ridgeland, MS at Sunchase Ridgeland Apts. Enjoy modern amenities and a refreshing pool. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-near-39157",
      "search_query": "fitness center apartments near 39157",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near 39157",
      "h2_subtitle": "Explore fitness center apartments near 39157. Sunchase Ridgeland Apts. offers state-of-the-art facilities for active lifestyles.",
      "page_copy": "Located conveniently near the 39157 area, Sunchase Ridgeland Apts. presents a living experience that caters to both comfort and an active lifestyle. Our fitness center apartments provide the perfect backdrop for health-conscious residents who value the convenience of state-of-the-art exercise facilities right at their doorstep. Our fully equipped fitness center ensures you can maintain your workout routine without leaving your community.\n\nIn addition to the modern fitness facilities, Sunchase Ridgeland Apts. features thoughtfully designed one and two-bedroom floor plans, complete with spacious walk-in closets and eat-in kitchens. The on-site amenities, including a refreshing pool and clubhouse, offer endless recreation options that complement your active lifestyle. Choose Sunchase Ridgeland Apts. for a lifestyle that seamlessly integrates fitness and comfort in a beautiful Ridgeland setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near 39157",
      "seo_description": "Discover apartments with a fitness center near 39157 at Sunchase Ridgeland Apts. Enjoy modern living with excellent amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "walk-in-closet-apartments-ridgeland-ms",
      "search_query": "walk-in closet apartments Ridgeland Mississippi",
      "category": "Amenity",
      "h1_title": "Walk-In Closet Apartments in Ridgeland, MS",
      "h2_subtitle": "Looking for walk-in closet apartments in Ridgeland, MS? Sunchase Ridgeland Apts. offers spacious living with abundant storage space.",
      "page_copy": "At Sunchase Ridgeland Apts., we understand the importance of having ample storage space. Our walk-in closet apartments in Ridgeland, MS, provide the perfect solution for residents seeking stylish and spacious living. Each one and two-bedroom apartment is designed with convenience in mind, featuring generous walk-in closets that accommodate a variety of storage needs.\n\nBeyond spacious closets, our community offers an impressive range of amenities, including a sparkling pool and a well-equipped fitness center. Enjoy the luxury of an eat-in kitchen and vinyl flooring in your apartment, making it both functional and modern. Discover how Sunchase Ridgeland Apts. can enhance your lifestyle with the perfect blend of style and convenience in the heart of Ridgeland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Walk-In Closet Apartments in Ridgeland, MS",
      "seo_description": "Find walk-in closet apartments in Ridgeland at Sunchase Ridgeland Apts. Enjoy spacious living with modern amenities. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "dishwasher-apartments-ridgeland-ms",
      "search_query": "dishwasher apartments in Ridgeland MS",
      "category": "Amenity",
      "h1_title": "Dishwasher Apartments in Ridgeland, MS",
      "h2_subtitle": "Experience the convenience of dishwasher apartments in Ridgeland, MS. Sunchase Ridgeland Apts. offers modern living with all the essentials.",
      "page_copy": "Welcome to Sunchase Ridgeland Apts., where convenience meets style in our dishwasher apartments in Ridgeland, MS. Each of our thoughtfully designed one and two-bedroom units includes modern amenities, such as a dishwasher, ensuring that you spend less time on chores and more time enjoying life. Our residences are perfect for those who appreciate efficiency blended with comfort.\n\nIn addition to the convenience offered by in-unit dishwashers, Sunchase Ridgeland Apts. features a wide range of amenities aimed at enhancing your lifestyle. Enjoy leisurely days by the pool, stay fit in our state-of-the-art fitness center, or host gatherings in our welcoming clubhouse. Discover the perfect blend of functionality and modern aesthetics in our Ridgeland community. Schedule your visit today and see firsthand the advantages of living at Sunchase Ridgeland Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Apartments in Ridgeland, MS",
      "seo_description": "Discover dishwasher apartments in Ridgeland at Sunchase Ridgeland Apts. Modern amenities for easy living. Book a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-39157",
      "search_query": "air conditioned apartments near 39157",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near 39157",
      "h2_subtitle": "Find comfortable air conditioned apartments near 39157 at Sunchase Ridgeland Apts., where modern amenities ensure a pleasant living experience.",
      "page_copy": "Escape the Mississippi heat with the comfort of air conditioned apartments near 39157, available at Sunchase Ridgeland Apts. Our community offers a selection of one and two-bedroom floor plans, all featuring efficient air conditioning systems to keep your living space cool and inviting year-round. Each apartment is designed with your comfort in mind, combining practicality with modern amenities to enhance your living experience.\n\nBeyond the cool comfort of air conditioning, Sunchase Ridgeland Apts. provides an array of amenities, including a refreshing pool and a recently updated fitness center. Residents enjoy the benefits of an eat-in kitchen, vinyl flooring, and spacious walk-in closets, all set within our vibrant Ridgeland community. Choose Sunchase Ridgeland Apts. for a lifestyle that offers both convenience and comfort in a prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near 39157",
      "seo_description": "Stay comfortable with air conditioned apartments at Sunchase Ridgeland Apts. near 39157. Modern amenities in a vibrant community. Tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-ridgeland-ms",
      "search_query": "1 bedroom apartments in Ridgeland MS",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Ridgeland, MS",
      "h2_subtitle": "Discover comfortable 1 bedroom apartments in Ridgeland, MS at Sunchase Ridgeland Apts. Perfectly designed for convenient living.",
      "page_copy": "Sunchase Ridgeland Apts. invites you to explore our charming 1 bedroom apartments in Ridgeland, MS. Each unit is thoughtfully crafted to provide a harmonious blend of comfort and style with features like spacious walk-in closets and modern eat-in kitchens. Our one-bedroom layouts are ideal for individuals or couples looking for a cozy yet functional home.\n\nLocated in the vibrant community of Ridgeland, Sunchase Ridgeland Apts. offers more than just comfortable living spaces. Residents can take advantage of our array of amenities, including a sparkling pool, a modern fitness center, and a welcoming clubhouse. The strategic location offers easy access to shopping, dining, and entertainment, providing the perfect setting for a dynamic yet relaxed lifestyle. Schedule a tour today and experience the best in Ridgeland living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Ridgeland, MS",
      "seo_description": "Explore 1 bedroom apartments at Sunchase Ridgeland Apts. in Ridgeland, MS. Spacious and modern living awaits. Schedule your visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-39157",
      "search_query": "2 bedroom apartments near 39157",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 39157",
      "h2_subtitle": "Explore spacious 2 bedroom apartments near 39157 at Sunchase Ridgeland Apts. Perfect for families and roommates seeking comfort and style.",
      "page_copy": "Discover the perfect home with our 2 bedroom apartments near 39157, available at Sunchase Ridgeland Apts. Designed with modern living in mind, these units provide ample space and convenience, featuring walk-in closets and inviting eat-in kitchens. Ideal for families or roommates, our spacious layouts cater to various living arrangements, underpinning comfort and functionality.\n\nSunchase Ridgeland Apts. doesn't just offer living spaces but a vibrant community enriched with amenities. Enjoy the refreshing pool, work on your fitness goals in the on-site gym, or relax in our community clubhouse. Situated in a prime location in Ridgeland, our apartments offer unparalleled access to local attractions and amenities, offering a balanced lifestyle of work, play, and relaxation. Come see why our community is the best choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 39157",
      "seo_description": "Find spacious 2 bedroom apartments near 39157 at Sunchase Ridgeland Apts. Experience modern living with great amenities. Tour our community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "apartments-near-holmes-community-college-ridgeland",
      "search_query": "apartments near Holmes Community College Ridgeland",
      "category": "School",
      "h1_title": "Apartments Near Holmes Community College Ridgeland",
      "h2_subtitle": "Convenience and comfort meet at Sunchase Ridgeland Apts., located near Holmes Community College in Ridgeland. Ideal for students and staff.",
      "page_copy": "Located just a short distance from Holmes Community College, Sunchase Ridgeland Apts. offers students and staff a convenient and welcoming place to call home. Our community features a blend of one and two-bedroom apartments designed for optimal comfort and ease. With spacious interiors, walk-in closets, and eat-in kitchens, each apartment provides a perfect retreat after a day of classes or work.\n\nBeyond the convenience of proximity to the college, our residents enjoy a range of community amenities. Take a break by our sparkling pool, stay fit in our state-of-the-art fitness center, or unwind in the clubhouse. The combination of modern living and a vibrant community atmosphere makes Sunchase Ridgeland Apts. the ideal location for anyone connected with Holmes Community College. Discover the perfect balance of work, study, and leisure right here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Holmes Community College Ridgeland",
      "seo_description": "Find convenient living near Holmes Community College at Sunchase Ridgeland Apts. Ideal for students and staff seeking modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "student-apartments-near-tougaloo-college-mississippi",
      "search_query": "student apartments near Tougaloo College Mississippi",
      "category": "School",
      "h1_title": "Student Apartments Near Tougaloo College, MS",
      "h2_subtitle": "Explore ideal student apartments near Tougaloo College, Mississippi at Sunchase Ridgeland Apts. Perfect for comfortable and convenient student living.",
      "page_copy": "Sunchase Ridgeland Apts. offers outstanding student apartments near Tougaloo College, Mississippi, providing a perfect home base for a successful college experience. Our one and two-bedroom floor plans cater to the needs of students seeking the perfect balance between serene study spaces and the comforts of home. Each apartment is equipped with modern amenities like spacious walk-in closets and eat-in kitchens, ensuring a functional and stylish living environment.\n\nOur community is tailored to student life, featuring amenities such as a refreshing pool for those study breaks, a fitness center to stay active, and a clubhouse for socializing. Conveniently located, Sunchase Ridgeland Apts. offers easy access to the campus and local conveniences, making it an ideal choice for students looking for both proximity and comfort. Make the most of your college years with us and discover a community that supports your academic journey.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Student Apartments Near Tougaloo College, MS",
      "seo_description": "Discover student apartments at Sunchase Ridgeland Apts. near Tougaloo College, Mississippi. Enjoy modern living and great amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "apartments-near-merit-health-river-oaks-ridgeland",
      "search_query": "apartments near merit health river oaks ridgeland",
      "category": "Hospital",
      "h1_title": "Apartments Near Merit Health River Oaks Ridgeland",
      "h2_subtitle": "Find comfort and convenience at Sunchase Ridgeland Apts., located near Merit Health River Oaks in Ridgeland. Ideal for healthcare professionals and patients.",
      "page_copy": "Sunchase Ridgeland Apts. is the ideal choice for those seeking apartments near Merit Health River Oaks in Ridgeland. Whether you're a healthcare professional or a patient needing nearby accommodation, our community offers the comfort and accessibility you need. Our one and two-bedroom apartments feature spacious layouts, including walk-in closets and eat-in kitchens, ensuring a comfortable home environment.\n\nOur residents enjoy a host of amenities designed for relaxation and convenience. Take a dip in our pool, maintain your workout routine at the fitness center, or unwind in the clubhouse. Located within easy reach of Merit Health River Oaks, Sunchase Ridgeland Apts. provides a perfect blend of convenient living, modern amenities, and a welcoming community atmosphere, making it a superb choice for those connected to the hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Merit Health River Oaks Ridgeland",
      "seo_description": "Discover convenient living at Sunchase Ridgeland Apts. near Merit Health River Oaks in Ridgeland. Ideal for healthcare professionals and patients.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "apartments-close-to-ummc-grants-ferry-ms",
      "search_query": "apartments close to ummc grants ferry ms",
      "category": "Hospital",
      "h1_title": "Apartments Close to UMMC Grants Ferry MS",
      "h2_subtitle": "Discover Sunchase Ridgeland Apts., close to UMMC Grants Ferry in MS. Perfect location for healthcare workers seeking comfortable living.",
      "page_copy": "Sunchase Ridgeland Apts. provides excellent apartment options close to UMMC Grants Ferry in Mississippi, perfect for healthcare professionals looking for a convenient commute. Our community offers one and two-bedroom apartments featuring spacious layouts, including walk-in closets and inviting eat-in kitchens, ensuring a comfortable and modern living experience.\n\nResidents enjoy a variety of community amenities designed to enhance their lifestyle. Whether it's taking a refreshing swim in our pool, staying fit in our fully-equipped fitness center, or relaxing in our clubhouse, Sunchase Ridgeland Apts. makes it easy to achieve work-life balance. Situated near UMMC Grants Ferry, our location offers easy access to workplace and essential amenities, creating a seamless living experience for healthcare workers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to UMMC Grants Ferry MS",
      "seo_description": "Explore Sunchase Ridgeland Apts. close to UMMC Grants Ferry MS. Ideal living for healthcare professionals seeking modern comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "apartments-near-lefleurs-bluff-state-park-ridgeland",
      "search_query": "apartments near LeFleur's Bluff State Park Mayes Lake Ridgeland",
      "category": "Park",
      "h1_title": "Apartments Near LeFleur's Bluff State Park",
      "h2_subtitle": "Discover Sunchase Ridgeland Apts. near LeFleur's Bluff State Park, Mayes Lake. Enjoy outdoor living with comfortable apartment convenience.",
      "page_copy": "Nestled near the scenic LeFleur's Bluff State Park and Mayes Lake, Sunchase Ridgeland Apts. offers exceptional apartment living for nature lovers and outdoor enthusiasts. Our one and two-bedroom units provide spacious walk-in closets and modern eat-in kitchens, ensuring comfort and functionality after a day exploring the park's trails and lakes.\n\nAt Sunchase Ridgeland, enjoy relaxing community amenities such as a refreshing pool and a modern fitness center, perfect for unwinding after an adventurous day outdoors. Our ideally situated location provides quick access to LeFleur's Bluff State Park while offering convenient proximity to urban amenities in Ridgeland. Experience the best of both worlds with serene park surroundings and the comforts of home at Sunchase Ridgeland Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near LeFleur's Bluff State Park",
      "seo_description": "Live close to nature at Sunchase Ridgeland Apts. near LeFleur's Bluff State Park. Enjoy modern amenities and outdoor adventures near Mayes Lake.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "ridgeland-apartments-close-to-freedom-ridge",
      "search_query": "Ridgeland apartments close to Freedom Ridge",
      "category": "Park",
      "h1_title": "Ridgeland Apartments Close to Freedom Ridge",
      "h2_subtitle": "Discover the convenience of Sunchase Ridgeland Apts., close to Freedom Ridge. Experience a vibrant lifestyle in a well-connected neighborhood.",
      "page_copy": "For those seeking a vibrant lifestyle in Ridgeland, Sunchase Ridgeland Apts. offers a prime location close to Freedom Ridge. Our thoughtfully designed one and two-bedroom apartments provide residents with spacious layouts, including walk-in closets and eat-in kitchens, perfect for creating a comfortable and functional home environment.\n\nSunchase Ridgeland offers a wealth of amenities that enhance everyday living. Residents can relax by the pool, hit the fitness center, or engage in community activities within our clubhouse. With Freedom Ridge just a short distance away, enjoy the perfect blend of a peaceful community atmosphere and easy access to local parks and outdoor spaces. Experience life at Sunchase Ridgeland, where convenience and comfort meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ridgeland Apartments Close to Freedom Ridge",
      "seo_description": "Discover Sunchase Ridgeland Apts. near Freedom Ridge. Enjoy modern apartment living with convenient access to local outdoor attractions and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "sunchase-ridgeland-apts-near-winners-circle-park-ms",
      "search_query": "Sunchase Ridgeland Apts near Winners Circle Park MS",
      "category": "Park",
      "h1_title": "Sunchase Ridgeland Apts Near Winners Circle Park",
      "h2_subtitle": "Live steps away from Winners Circle Park at Sunchase Ridgeland Apts. Experience a blend of modern living and outdoor leisure in Ridgeland, MS.",
      "page_copy": "Sunchase Ridgeland Apts. offers the perfect home for those who love the outdoors, located a stone's throw away from Winners Circle Park in Ridgeland, MS. Our spacious one and two-bedroom apartments come equipped with modern amenities such as walk-in closets and eat-in kitchens, providing a comfortable setting for your everyday life.\n\nResidents enjoy excellent community features like a sparkling pool and state-of-the-art fitness center, adding to the array of activities available just outside your door. With Winners Circle Park nearby, enjoy easy access to nature trails, playgrounds, and picnic areas. Sunchase Ridgeland Apts. combines the convenience of city living with the peacefulness of nature, making it an ideal choice for renters seeking a balanced lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sunchase Ridgeland Apts Near Winners Circle Park",
      "seo_description": "Discover Sunchase Ridgeland Apts near Winners Circle Park. Enjoy modern apartments and outdoor activities in Ridgeland, MS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "apartments-in-ridgeland-by-old-trace-park",
      "search_query": "apartments in Ridgeland by Old Trace Park",
      "category": "Park",
      "h1_title": "Apartments in Ridgeland by Old Trace Park",
      "h2_subtitle": "Sunchase Ridgeland Apts. offers a prime location by Old Trace Park. Enjoy modern comforts with easy access to outdoor recreation in Mississippi.",
      "page_copy": "Located near the serene landscapes of Old Trace Park, Sunchase Ridgeland Apts. presents an ideal living destination in Ridgeland, Mississippi. Our spacious one and two-bedroom units feature modern amenities like walk-in closets and inviting eat-in kitchens, providing an ideal mix of comfort and functionality.\n\nSunchase Ridgeland residents relish in community perks like a refreshing swimming pool and a cutting-edge fitness center. The proximity to Old Trace Park offers an abundance of outdoor activities, from walking trails to picnics by the water. Discover the perfect blend of leisure and lifestyle with the convenience of city amenities and the relaxation of park-side living at Sunchase Ridgeland Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments in Ridgeland by Old Trace Park",
      "seo_description": "Experience the best of Ridgeland living at Sunchase Ridgeland Apts., located near Old Trace Park. Enjoy modern living with easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165630",
      "source": "generator",
      "page_item_url": "flowood-nature-park-nearby-ridgeland-apartments",
      "search_query": "Flowood Nature Park nearby Ridgeland apartments",
      "category": "Park",
      "h1_title": "Flowood Nature Park Nearby Ridgeland Apartments",
      "h2_subtitle": "Explore the beauty of Flowood Nature Park from Sunchase Ridgeland Apts. Enjoy a blend of modern living and nature just minutes away.",
      "page_copy": "Nestled in the vibrant town of Ridgeland, Sunchase Ridgeland Apts. offers the perfect blend of urban convenience and natural beauty, just moments from Flowood Nature Park. Residents of our community enjoy spacious one and two-bedroom apartments with modern features like walk-in closets and eat-in kitchens that make everyday living a breeze.\n\nWith amenities such as a sparkling pool and state-of-the-art fitness center, Sunchase Ridgeland Apts. provides a lifestyle of luxury and leisure. The nearby Flowood Nature Park invites you to explore scenic trails and tranquil picnic spots, offering an escape into nature's serenity. Experience the ideal balance of modern comforts and outdoor exploration at Sunchase Ridgeland Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
      "featured_image_media": {
        "alt_text": "Indoor swimming pool with lush greenery and rocks.",
        "public_id": "019cfb48-8438-74b8-90fd-906fe588e04f",
        "storage_key": "property/6767906449165630/019cfb48-8438-74b8-90fd-906fe588e04f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flowood Nature Park Nearby Ridgeland Apartments",
      "seo_description": "Live at Sunchase Ridgeland Apts., close to Flowood Nature Park. Enjoy modern living with nature trails and amenities nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5218"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-VLJL8Z2WKP"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041152029"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/sunchase-ridgeland-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P5DTMKPK"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165630/019d1bda-053d-7788-aca6-567cb2110795.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "0881c3c1-730f-42e3-9d4a-685bdec948b8"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-707-9296"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6504af797302b3c9a24308cc"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IitxU0s4ZEdxazRIZld3WE0zU1BRSHc9PSIsInZhbHVlIjoiVXpNeDVRZFY0clBCZjZZZ2VPSGZHdz09IiwibWFjIjoiNGFhZWM3ZjczMWMyMDQyNDRkMGE4MGU0MDJlMThjYzJkNjlmZTY4YmZhZDc4MjJmNmE5Yjc3NmJhMjY1OGQzMyJ9"
    }
  ],
  "custom_qb_id": "5218",
  "custom_ga4_id": "G-VLJL8Z2WKP",
  "custom_repli_id": "10041152029",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/sunchase-ridgeland-apartments/register/",
  "custom_google_gtm_id": "GTM-P5DTMKPK",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165630/019d1bda-053d-7788-aca6-567cb2110795.pdf",
  "custom_rentgrata_property_id": "0881c3c1-730f-42e3-9d4a-685bdec948b8",
  "custom_ppc_tracking_phone_number": "844-707-9296",
  "custom_residentboost_apartment_id": "6504af797302b3c9a24308cc",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IitxU0s4ZEdxazRIZld3WE0zU1BRSHc9PSIsInZhbHVlIjoiVXpNeDVRZFY0clBCZjZZZ2VPSGZHdz09IiwibWFjIjoiNGFhZWM3ZjczMWMyMDQyNDRkMGE4MGU0MDJlMThjYzJkNjlmZTY4YmZhZDc4MjJmNmE5Yjc3NmJhMjY1OGQzMyJ9"
};

export const generatedAt = '2026-08-27T21:36:10.819Z';
